import React, { useState, useEffect, useRef } from "react";
import { FaTrash, FaSearch, FaVideo, FaUnlink, FaQuestionCircle, FaLink } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import "./EditTvplayouts.css";
import { Link, useParams } from "react-router-dom";
import backarrow from "../../components/Images/backarrow.svg";
import { Table } from "react-bootstrap";
import { CiShare1, CiSquarePlus } from "react-icons/ci";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import Response_Processing from "../../layout/Others/Response_Processing";
import { FaEdit, FaCheck, FaPen, FaTimes, FaPlus } from "react-icons/fa";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import PlayoutPlayer from "./PlayoutPlayer";
import AdminSwitch from "../../components/CommonComponents/AdminSwitch";
import { useMyContext } from '../../components/Provider/CommonProvider'
import AdminCustomInput from "../../components/CommonComponents/AdminCustomInput";
import MessageSubHeading from "../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import AdminBackNavigation from "../../components/CommonComponents/AdminBackNavigation";
import AdminCustomSelect from "../../components/CommonComponents/AdminCustomSelect";
import FormContainer from "../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../components/CommonComponents/Wrapper";
import RightWrapper from "../../components/CommonComponents/RightWrapper";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import AdminImageUploadZone from "../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../components/CommonComponents/AdminCustomButton";
import AdminSaveHeader from "../../components/CommonComponents/AdminSaveHeader";
import useCompressImageConfig from "../../components/CommonApis/Compressimageapi";
import breakAd from '../../components/Images/break-ad.png';
import { IoIosArrowDown, IoMdInformationCircle } from "react-icons/io";
import MessageBox from "../../components/CommonComponents/MessageBox";
import AdminVideoPlayer from "../../components/CommonComponents/AdminVideoPlayer";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";
import BandwidthAnalytics from "./BandwidthAnalytics";
import AdminCustomURLCopy from "../../components/CommonComponents/AdminCustomURLCopy";
import { WebPlayerView } from 'unified-video-framework/web'
import { connect } from "react-redux";
import Select from "react-select";
import NexusPlayer from "../../components/CommonComponents/NexusPlayer";
import { MdAddCircle } from "react-icons/md";
import { RxReload } from "react-icons/rx";
import AdminTooltip from "../../components/CommonComponents/AdminTooltip";
import AdminCustomArea from "../../components/CommonComponents/AdminCustomArea";

const EditTvplayouts = ({ adminSetting, storageSetting, userDetails, siteTheme, onlyPermission }) => {

    // I'd initialization
    const { id } = useParams();
    const labelSource = 'tv-playout-edit'
    const { fetchRequest, validateOrientationBySlug, buildDynamicSubText, globalImageUplaodAPI, handleFileChangeProvider } = useMyContext()

    // Api's
    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/playout/edit/${id}`
    const stopApi = `${baseURL}/admin/playout/stopStream/${id}`
    const updateApi = `${baseURL}/admin/playout/update/${id}`
    const deleteApi = `${baseURL}/admin/playout/delete/${id}`
    const scheduleApi = `${baseURL}/admin/playout/schedule`
    const appendScheduleApi = `${baseURL}/admin/playout/append-schedule`
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
    const hlsSignalApi = `${baseURL}/api/check-hls-signal`
    const imageApi = globalImageUplaodAPI();
    const videoApi = `${baseURL}/admin/library/upload`
    const videoIndexApi = `${baseURL}/admin/playout/library-video-index`
    const RTMPStoreApi = `${baseURL}/admin/setting/rmtp/store`

    // Consolidated state management
    const [state, setState] = useState({
        playout: { data: "", response_loading: true, response_error: "", response_status: false },
        scheduledContents: [],
        errors: {},
        ui: {
            showOverlay: false,
            openBreakModal: false,
            openProgramModal: false,
            openVideoUploadModal: false,
            loading: true,
            isFormValid: true,
            vodLoading: false,
            openRTMPModal: false
        },
        files: {
            coverImage: null,
            playerImage: null
        },
        settings: {
            firstDate: null,
            hlsSignal: false,
            withOutRefresh: false
        },
        programForm: {
            name: "",
            duration: "00:05:00",
            url: ""
        },
        labelDisplay: [],
        newsTickerSettings: {},
        newsTickerContents: [{ intro_text: "", heading_text: "", news_text: "" }],
        newRTMP: { platform: 'custom', source_type: '', title: '', rtmp_url: '', hls_url: '', watch_youtube_url: '', stream_key: '', custom_rtmp_base: '' },
        editBaseUrl: false
    });
    const [isStreaming, setIsStreaming] = useState(false)
    const [playerKey, setPlayerKey] = useState(0)
    const accessOption = [
        { value: 'guest', name: 'Guest (everyone)' },
        { value: 'registered', name: 'Registered Users( Must register to watch )' },
        // { value: 'subscriber', name: 'Subscriber ( Must subscribe to watch )' },
        { value: 'ppv', name: 'PPV Users (Pay per movie)' }
    ]

    // Destructure state for easier access
    const { playout: playoutData, scheduledContents, errors: playoutDataError, ui, files, settings, programForm, labelDisplay, newsTickerSettings, newsTickerContents, newRTMP } = state;
    const { showOverlay, openBreakModal, openProgramModal, openVideoUploadModal, openRTMPModal, loading, vodLoading, isFormValid } = ui;
    const { coverImage: coverImageFile, playerImage: playerImageFile } = files;
    const { firstDate, hlsSignal, withOutRefresh } = settings;

    // Helper functions for state updates
    const updateState = (updates) => {
        setState(prev => ({ ...prev, ...updates }));
    };

    const updatePlayout = (playoutUpdates) => {
        setState(prev => ({
            ...prev,
            playout: {
                ...prev.playout,
                play_out: {
                    ...prev.playout.play_out,
                    ...playoutUpdates
                }
            }
        }));
    };

    const updateTickerSettings = (updates) => {
        setState(prev => ({
            ...prev,
            playout: {
                ...prev.playout,
                play_out: {
                    ...prev.playout.play_out,
                    ticker_settings: {
                        ...prev.playout.play_out.ticker_settings,
                        ...updates
                    }
                }
            }
        }));
    };
    const updateNewRTMP = (updates) => {
        setState(prev => ({
            ...prev,
            newRTMP: {
                ...prev.newRTMP,
                ...updates
            }
        }));
    };


    const updateErrors = (errorUpdates) => {
        setState(prev => ({
            ...prev,
            errors: { ...prev.errors, ...errorUpdates }
        }));
    };

    const updateUI = (uiUpdates) => {
        setState(prev => ({
            ...prev,
            ui: { ...prev.ui, ...uiUpdates }
        }));
    };

    const updateSettings = (settingsUpdates) => {
        setState(prev => ({
            ...prev,
            settings: { ...prev.settings, ...settingsUpdates }
        }));
    };

    const updateNewsTickerSettings = (newsTickerSettingsUPdate) => {
        setState(prev => ({
            ...prev,
            ...newsTickerSettingsUPdate
        }))
    }

    const updateNewsTickerContents = (data) => {
        setState(prev => ({
            ...prev,
            ...data
        }))
    }

    const { compressResolutionFormat } = useCompressImageConfig();
    const combinedRef = useRef({ title: null, playout_mode: null, category_id: null, category_checkbox: null });
    const analyticsRef = useRef(null);

    const nowUTC = new Date();
    const startTimeUTC = new Date(playoutData?.play_out?.start_time);
    const endTimeUTC = new Date(playoutData?.play_out?.end_time);

    const shouldShowPlayer = nowUTC >= startTimeUTC && nowUTC < endTimeUTC;



    const tickerFields = ["position", "speed", "gap", "backgroundColor"];

    // handle input
    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;

        const finalValue =
            type === "checkbox" ? (checked ? 1 : 0) : value;

        if (tickerFields.includes(name)) {
            updateTickerSettings({ [name]: finalValue });
        } else {
            updatePlayout({ [name]: finalValue });
        }

        updateErrors({ [name]: '' });
    };

    const PLATFORM_OPTIONS = [
        { value: 'custom', name: 'Custom' },
        { value: 'youtube', name: 'YouTube' },
        { value: 'facebook', name: 'Facebook' },
        { value: 'instagram', name: 'Instagram' },
        { value: 'linkedin', name: 'LinkedIn' },
        { value: 'twitch', name: 'Twitch' },
    ];

    const PLATFORM_RTMP_URLS = {
        youtube: 'rtmp://a.rtmp.youtube.com/live2/',
        facebook: 'rtmps://live-api-s.facebook.com:443/rtmp/',
        instagram: 'rtmps://live-upload.instagram.com:443/rtmp/',
        linkedin: 'rtmp://live.linkedin.com:1935/rtmp/',
        twitch: 'rtmp://live.twitch.tv/app/',
    };

    const PLATFORM_WATCH_URLS = {
        youtube: 'https://www.youtube.com/watch?v=',
        facebook: 'https://www.facebook.com/live/',
        instagram: 'https://www.instagram.com/',
        linkedin: 'https://www.linkedin.com/video/live/',
        twitch: 'https://www.twitch.tv/',
    };

    const isRTMPCustomPlatform = !newRTMP?.platform || newRTMP?.platform === 'custom';
    const selectedRTMPPlatformUrl = PLATFORM_RTMP_URLS[newRTMP?.platform] || '';

    const rtmphandleInput = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'editBaseUrl') {
            setState(prev => ({ ...prev, editBaseUrl: checked }));
            if (!checked) {
                const defaultBase = PLATFORM_RTMP_URLS[newRTMP?.platform] || '';
                updateNewRTMP({ custom_rtmp_base: '', rtmp_url: defaultBase + (newRTMP?.stream_key || '') });
            }
            return;
        }

        if (name === 'platform') {
            const platformUrl = PLATFORM_RTMP_URLS[value] || '';
            setState(prev => ({ ...prev, editBaseUrl: false }));
            updateNewRTMP({
                platform: value,
                stream_key: '',
                custom_rtmp_base: '',
                rtmp_url: value === 'custom' ? '' : platformUrl,
                hls_url: value === 'custom' ? (newRTMP?.hls_url || '') : '',
                watch_youtube_url: '',
                source_type: value === 'custom' ? 'default' : 'social_media',
            });
        } else if (name === 'custom_rtmp_base') {
            updateNewRTMP({ custom_rtmp_base: value, rtmp_url: value + (newRTMP?.stream_key || '') });
        } else if (name === 'stream_key') {
            const baseUrl = newRTMP?.custom_rtmp_base || PLATFORM_RTMP_URLS[newRTMP?.platform] || '';
            updateNewRTMP({ stream_key: value, rtmp_url: baseUrl + value });
        } else {
            updateNewRTMP({ [name]: value });
        }

        updateErrors({ [name]: '' });
    };

    const newsTickerHandleInput = (e, index) => {
        const { name, value } = e.target;
        setState(prev => {
            const updateData = [...prev.newsTickerContents]
            updateData[index] = {
                ...updateData[index],
                [name]: value
            }

            return {
                ...prev,
                newsTickerContents: updateData
            }
        })
    }

    const emptyRow = { intro_text: "", heading_text: "", news_text: "" };

    const newsTickerHandleClick = (type, index) => {
        setState(prev => {
            const updated = [...prev.newsTickerContents];

            if (type === "add") {
                updated.splice(index + 1, 0, { ...emptyRow });
            }

            if (type === "remove") {
                if (updated.length === 1) {
                    setState(prev => ({
                        ...prev,
                        newsTickerContents: [emptyRow]
                    }))
                }
                updated.splice(index, 1);
            }

            return {
                ...prev,
                newsTickerContents: updated
            };
        });
    };


    const handleMultiSelect = (selectedOptions) => {

        const value = selectedOptions?.map((item) => item?.value)

        updatePlayout({ ['destination_rtmp']: value });
        updateErrors({ ['destination_rtmp']: "" });
    };

    const handleCategoryChange = (selectedCategoryIds) => {
        updatePlayout({ category_id: selectedCategoryIds });
        updateErrors({ category_id: "" });
    };


    // Optimized state management functions
    const updateScheduledContents = (contents) => {
        setState(prev => ({ ...prev, scheduledContents: contents }));
    };

    const getScheduledItemStartDate = (item) => {
        const startDate = new Date(item?.startTime || item?.start_time);
        return Number.isNaN(startDate.getTime()) ? null : startDate;
    };

    const getScheduledItemEndDate = (item) => {
        const endDate = new Date(item?.endTime || item?.end_time);
        if (!Number.isNaN(endDate.getTime())) return endDate;

        const startDate = getScheduledItemStartDate(item);
        if (!startDate) return null;

        const durationInSeconds = typeof item?.duration === 'number'
            ? item.duration
            : parseDuration(item?.duration);

        if (!Number.isFinite(durationInSeconds)) return null;

        return new Date(startDate.getTime() + durationInSeconds * 1000);
    };

    const removePastScheduledContents = (contents, referenceTime = new Date()) => {
        if (!Array.isArray(contents)) return [];

        const referenceDate = new Date(referenceTime);
        if (Number.isNaN(referenceDate.getTime())) return contents;

        return contents.filter((item) => {
            if (item?.isNewQueueItem) return true;

            const endDate = getScheduledItemEndDate(item);
            return !endDate || endDate > referenceDate;
        });
    };

    const handleScrollToAnalytics = () => {
        analyticsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleClearSelectFile = (value) => {
        const fileUpdates = { [value === 'image' ? 'coverImage' : 'playerImage']: null };
        setState(prev => ({
            ...prev,
            files: { ...prev.files, ...fileUpdates },
            errors: { ...prev.errors, [value]: '' },
            ui: { ...prev.ui, isFormValid: true }
        }));
    };

    const handleFileChange = async (event) => {
        const { files, name, dataset } = event.target
        const checkSize = compressResolutionFormat?.live === 1
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

        updateErrors({ [name]: '' });
        // Don't clear existing image data immediately - keep it until successful update

        if (files?.length > 0) {
            const newFile = files[0];

            // Validate mime type first
            if (!allowedTypes.includes(newFile?.type)) {
                updateErrors({ [name]: "Only JPG, JPEG, WEBP and PNG files are allowed." });
                updateUI({ isFormValid: false });
                combinedRef.current?.[name]?.focus?.();
                return;
            }

            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };

            await readFile(newFile);
            let formisValid = true;

            // Dynamic orientation check if provided via data-orientation
            if (dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                const result = await validateOrientationBySlug(newFile, dataset.orientation);
                if (!result.ok) {
                    let msg = 'Selected image does not match the required orientation.';
                    if (result?.expected) {
                        const ratio = result?.ratio || `${result.expected.width}:${result.expected.height}`;
                        msg = `Image must be in ${ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                    } else if (result?.actual) {
                        const s = String(result.slug);
                        if (s === 'landscape') msg = `Please upload a landscape image (width > height). Uploaded: ${result.actual.width}x${result.actual.height}.`;
                        else if (s === 'portrait') msg = `Please upload a portrait image (height > width). Uploaded: ${result.actual.width}x${result.actual.height}.`;
                        else if (s === 'square') msg = `Please upload a square image (width = height). Uploaded: ${result.actual.width}x${result.actual.height}.`;
                    }
                    updateErrors({ [name]: msg });
                    updateUI({ isFormValid: false });
                    return;
                }
            }

            // Fallback static checks when compress image check is enabled and no dynamic orientation is specified
            if (!dataset?.orientation && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                if (name === 'image') {
                    const isValidSizeVertical = await validateImageRatio(newFile, 9 / 16, 1080, 1920);
                    if (!isValidSizeVertical) {
                        updateErrors({ [name]: "Image must be in 9:16 Ratio or 1080x1920px." });
                        formisValid = false;
                    }
                }
                if (name === 'player_image') {
                    const isValidSizeHorizontal = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                    if (!isValidSizeHorizontal) {
                        updateErrors({ [name]: "Image must be in 16:9 Ratio or 1280x720px." });
                        formisValid = false;
                    }
                }
            }

            if (!formisValid) {
                updateUI({ isFormValid: false });
                combinedRef.current?.[name]?.focus?.();
                return;
            }

            // Set file only after successful validation
            if (name === 'image') {
                setState(prev => ({
                    ...prev,
                    files: { ...prev.files, coverImage: newFile }
                }));
            }
            if (name === 'player_image') {
                setState(prev => ({
                    ...prev,
                    files: { ...prev.files, playerImage: newFile }
                }));
            }
            updateUI({ isFormValid: true });
        }
    }

    const handleAddVideo = (item) => {
        // if (Number(playoutData?.play_out?.streaming_status) === 1) return

        const queueContents = scheduledContents;
        const lastQueueItem = queueContents[queueContents.length - 1];
        const prevEndTime = queueContents.length > 0
            ? new Date(lastQueueItem?.endTime || lastQueueItem?.end_time || lastQueueItem?.startTime || lastQueueItem?.start_time)
            : new Date(firstDate);

        const durationInSeconds = parseDuration(item.duration) || 0;

        const startTimeLocal = new Date(prevEndTime);
        const endTimeLocal = new Date(startTimeLocal.getTime() + (durationInSeconds * 1000));

        const startTimeUTC = startTimeLocal.toISOString();
        const endTimeUTC = endTimeLocal.toISOString();

        const newVideo = {
            content: item.title,
            startTime: startTimeUTC,
            endTime: endTimeUTC,
            duration: durationInSeconds,
            action: "Delete",
            live_stream_id: item?.live_stream_id,
            video_id: item?.video_id,
            type: item?.type,
            url: item?.url,
            library_tag: item?.library_tag,
            isNewQueueItem: Number(playoutData?.play_out?.streaming_status) === 1
        };
        updateScheduledContents([...scheduledContents, newVideo]);

        // Update isScheduleActive and disabledDestinationIds in the consolidated state
        setState(prev => ({
            ...prev,
            ui: { ...prev.ui, isScheduleActive: true },
            settings: {
                ...prev.settings,
                disabledDestinationIds: [...(prev.settings.disabledDestinationIds || []), item.id]
            }
        }));
    };

    const inputStartDateTimeChange = async (item) => {
        const selectedLocalTime = parseInputToLocalDate(item);
        const utcConvertedstartTime = selectedLocalTime.toISOString();
        updateErrors({ ['date']: '' });

        let currentTime = new Date(utcConvertedstartTime);
        // console.log(`selected time: ${selectedLocalTime}, current time: ${new Date()}`);

        if (selectedLocalTime < new Date()) {
            toast.error('Do not select past time!');
            return;
        }

        const updatedContents = []

        for (let i = 0; i < scheduledContents.length; i++) {
            const content = scheduledContents[i];
            const startTime = new Date(currentTime);
            const endTime = new Date(startTime.getTime() + (content.duration * 1000));

            updatedContents.push({
                ...content,
                startTime: startTime.toISOString(),
                endTime: endTime.toISOString()
            });

            currentTime = endTime;
        }

        updateScheduledContents(updatedContents);
        updateSettings({ firstDate: selectedLocalTime });
    }

    const formValidation = () => {
        let formIsValid = true;
        if (!playoutData?.play_out?.name) {
            updateErrors({ name: "Title cannot be empty." });
            combinedRef.current['name'].focus()
            formIsValid = false;
        }
        const rtmpList = playoutData?.play_out?.destination_rtmp
        if (!rtmpList || rtmpList.length === 0 || rtmpList[0] == null) {
            updateErrors({ destination_rtmp: "Select destination RTMP." });
            combinedRef.current['destination_rtmp'].focus()
            formIsValid = false;
        }
        // if (!playoutData?.play_out?.access) {
        //     updateErrors({ access: "Select destination User access." });
        //     combinedRef.current['access'].focus()
        //     formIsValid = false;
        // }
        if (playoutData?.play_out?.access == 'ppv' && !playoutData?.play_out?.ppv_price) {
            updateErrors({ ppv_price: "Enter the PPV price." });
            combinedRef.current['access'].focus()
            formIsValid = false;
        }
        // if (!playoutData?.play_out?.substitute_id) {
        //     updateErrors({ substitute_id: "Select Substitute video" });
        //     combinedRef.current['substitute_id'].focus();
        //     formIsValid = false;
        // }
        if (!playoutData?.play_out?.playout_types) {
            updateErrors({ playout_types: "Select playout type." });
            combinedRef.current['playout_types'].focus()
            formIsValid = false;
        }
        // if (playoutData?.play_out?.image?.toLowerCase().endsWith('default_vertical_image.webp') && !coverImageFile) {
        //     updateErrors({ image: "Please upload image." });
        //     combinedRef.current['image'].focus()
        //     formIsValid = false;
        // }
        // if (playoutData?.play_out?.player_image?.toLowerCase().endsWith('default_horizontal_image.webp') && !playerImageFile) {
        //     updateErrors({ player_image: "Please upload Player image." });
        //     combinedRef.current['player_image'].focus()
        //     formIsValid = false;
        // }
        if (playoutDataError?.image) {
            combinedRef.current['image'].focus()
            formIsValid = false;
        }
        if (playoutDataError?.player_image) {
            combinedRef.current['player_image'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleStore = async (e) => {
        if (id) {
            if (formValidation() && isFormValid) {
                await handleUpdate()
            }
        }
    }

    const durationChecker = async (e) => {
        let formIsValid = true;
        const value = scheduledContents.map((item, index) => {
            console.log("item id: " + JSON.stringify(item));
            console.log("item index: " + index);

            const duration = item.duration;
            if (duration == 0 || duration == null || duration == "") {
                console.log("duration error detected.")
                updateErrors({ [`scheduleDuration-${index}`]: "Duration cannot be zero." });
                combinedRef.current[`scheduleDuration-${index}`].focus()
                formIsValid = false;

            }
        })
        return formIsValid;
    }

    const timeLimit = async () => {
        let formIsValid = true;
        let currentDuration = 0;

        const existingDuration = Number(playoutData?.play_out?.schedule_duration || 0);

        scheduledContents.forEach((item) => {
            const duration = Number(item.duration);
            currentDuration += duration;
        });

        const updatedDuration = existingDuration + currentDuration;

        updateState({
            playout: {
                ...playoutData,
                play_out: {
                    ...playoutData.play_out,
                    schedule_duration: updatedDuration
                }
            }
        });

        return formIsValid;
    }

    const handleSchedule = async (e) => {
        console.log("duration when schedule:" + JSON.stringify(scheduledContents));

        e.preventDefault();
        const formvalid = await formValidation();
        const formdurationValid = await durationChecker();
        // const formdestinationValid = await destinationChecker();
        const formdlimitValid = await timeLimit();

        const scheduleStartTime = new Date(scheduledContents[0]?.startTime)
        const currentTime = new Date();
        const oneMinutesFromNow = new Date(currentTime.getTime() + 10 * 1000);

        if (scheduleStartTime < oneMinutesFromNow) {
            updateErrors({ date: "The start time must be at least 1 minutes from now." });
            combinedRef.current['date'].focus()
            toast.error('Schedule start time must be at least 1 minutes from now!');
            return;
        }

        if (id && formvalid && isFormValid && formdurationValid && formdlimitValid) {
            await handleStore()
            await handleScheduleProgram()
        }
    }

    const handleStop = async () => {
        try {
            const result = await fetchRequest({ method: 'GET', url: stopApi })
            if (result?.status) {
                const stoppedAt = new Date(result?.stopped_at || result?.data?.stopped_at || Date.now());
                toast.success(result?.message)
                setIsStreaming(false)
                setState(prev => {
                    const remainingContents = removePastScheduledContents(prev.scheduledContents, stoppedAt);

                    return {
                        ...prev,
                        scheduledContents: remainingContents,
                        settings: {
                            ...prev.settings,
                            firstDate: getScheduledItemStartDate(remainingContents[0]) || stoppedAt
                        },
                        playout: {
                            ...prev.playout,
                            play_out: {
                                ...prev.playout.play_out,
                                streaming_status: 0
                            }
                        }
                    };
                });
                setPayoutsFilelivelist(prev => removePastScheduledContents(prev, stoppedAt));
                setSelectedLivedata(prev => removePastScheduledContents(prev, stoppedAt).filter(item => item.type === "live"));
            }
        } catch (error) {
            console.error(error?.result?.message)
            toast.error(error?.result?.message)
        }
    }

    const handleScheduleProgram = async () => {
        updateUI({ showOverlay: true });

        const saveSchedule = {
            playout_id: playoutData?.play_out?.id,
            Schedule: scheduledContents?.map((video) => {

                const scheduleItem = {
                    start_time: video?.startTime,
                    duration: formatDuration(video?.duration),
                    type: video?.type,
                    url: video?.url,
                };

                if (video?.video_id) {
                    scheduleItem.video_id = video?.video_id;
                } else if (video?.live_stream_id) {
                    scheduleItem.live_stream_id = video?.live_stream_id;
                }

                return scheduleItem;
            }),
        };

        try {

            const result = await fetchRequest({
                method: 'POST',
                url: `${scheduleApi}`,
                params: {},
                data: saveSchedule,
            });
            toast.success("Schedule processed successfully!");

            if (result?.status) {
                console.log("set schedule response: " + JSON.stringify(result));
                // toast.success(result?.message || "Scheduled successful");

                updateState({
                    playout: {
                        ...playoutData,
                        play_out: {
                            ...playoutData.play_out,
                            streaming_status: 2
                        }
                    }
                });

                updateSettings({ withOutRefresh: !withOutRefresh });
                scheduleNextStatusCheck(result.remaining_time_to_start);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message;
            toast.error(errorMessage + (error?.response?.data?.error || ""));
        } finally {
            updateUI({ showOverlay: false });
        }
    }

    // ── Append new programs to an already-live playout ────────────────────────
    const handleUpdateNewPrograms = async () => {
        // Pull only the items the admin added while the stream was live
        const newItems = scheduledContents.filter((item) => item?.isNewQueueItem === true);

        if (newItems.length === 0) {
            toast.error('No new programs to append. Please add at least one program first.');
            return;
        }

        updateUI({ showOverlay: true });

        const appendPayload = {
            playout_id: playoutData?.play_out?.id,
            Schedule: newItems.map((video) => {
                const item = {
                    start_time: new Date(video.startTime).toISOString(),
                    duration: formatDuration(video.duration),
                    type: video.type,
                    url: video.url || null,
                };
                if (video.video_id) item.video_id = video.video_id;
                if (video.live_stream_id) item.live_stream_id = video.live_stream_id;
                return item;
            }),
        };

        try {
            const result = await fetchRequest({
                method: 'POST',
                url: appendScheduleApi,
                data: appendPayload,
            });

            if (result?.status) {
                toast.success(result?.message || 'Programs appended to the live queue successfully.');

                // Mark all newly-appended items as locked (no longer editable)
                const clearedContents = scheduledContents.map((item) =>
                    item?.isNewQueueItem ? { ...item, isNewQueueItem: false } : item
                );
                updateScheduledContents(clearedContents);

                // Refresh playout data so end_time reflects the new queue
                updateSettings({ withOutRefresh: !withOutRefresh });
            }
        } catch (error) {
            const msg = error?.response?.data?.message || error?.message || 'Failed to append programs.';
            toast.error(msg);
        } finally {
            updateUI({ showOverlay: false });
        }
    };

    const handleUpdate = async () => {


        updateUI({ showOverlay: true });

        const updateData = {
            name: playoutData?.play_out?.name,
            status: playoutData?.play_out?.status,
            is_ads: playoutData?.play_out?.is_ads,
            playout_types: playoutData?.play_out?.playout_types,
            start_time: firstDate,
            retain_value: playoutData?.play_out?.retain_value,
            streamkey_retain: playoutData?.play_out?.streamkey_retain,
            live_id: playoutData?.play_out?.destination_rtmp,
            category_id: playoutData?.play_out?.category_id || [],
            substitute_id: playoutData?.play_out?.substitute_id,
            access: playoutData?.play_out?.access,
            ppv_price: playoutData?.play_out?.access === 'ppv' ? playoutData?.play_out?.ppv_price : null,
            ticker_settings: playoutData?.play_out?.ticker_settings,
            newsTickerContents: newsTickerContents,
            description: playoutData?.play_out?.description,
            regions_id: selectedRegions?.map((option) => option?.value)
        };

        // console.log("update API before res: " + JSON.stringify(updateData) );

        try {
            const result = await fetchRequest({
                method: 'PATCH',
                url: `${updateApi}`,
                params: {},
                data: updateData,
            });

            // console.log("update API response: ", result);

            if (result?.status) {
                const playoutId = playoutData?.play_out?.id;
                if (coverImageFile || playerImageFile) {
                    await handleFileUpload(playoutId, 'playout-image');
                }
                toast.success(result?.message || "Update successful");
                updateSettings({ withOutRefresh: !withOutRefresh });
            }
        } catch (error) {
            toast.error(error?.response?.data?.errors?.[0]?.msg || "Unknown Error");
        } finally {
            updateUI({ showOverlay: false });
        }

    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();

            if (name === 'playout-image') {

                const modelName = "AdminPlayout";
                const imageFields = [];

                if (coverImageFile) {
                    formDataAdd.append('image', coverImageFile);
                    imageFields.push('image');
                }

                if (playerImageFile) {
                    formDataAdd.append('player_image', playerImageFile);
                    imageFields.push('player_image');
                }

                formDataAdd.append('modelName', modelName);
                formDataAdd.append('id', id);

                imageFields.forEach(field => {
                    formDataAdd.append('imageFields[]', field);
                });

                const response = await fetchRequest({
                    method: 'POST',
                    url: imageApi,
                    params: {},
                    data: formDataAdd,
                });

                if (response?.status) {
                    updateState({
                        playout: {
                            ...playoutData,
                            play_out: {
                                ...playoutData.play_out,
                                image: response?.data?.image || playoutData?.play_out?.image,
                                player_image: response?.data?.player_image || playoutData?.play_out?.player_image
                            }
                        }
                    });
                }
            }
            setState(prev => ({
                ...prev,
                files: {
                    ...prev.files,
                    coverImage: null,
                    playerImage: null
                }
            }));
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleUrlBreak = async () => {
        const breakUrl = playoutData?.play_out?.breakUrl

        const m3u8Regex = /\.m3u8$/i;
        const mp4Regex = /\.mp4$/i;

        if (!breakUrl) {
            updateErrors({ breakUrl: "URL cannot be empty." });
            combinedRef.current['breakUrl'].focus()
        } else if (!m3u8Regex.test(breakUrl) && !mp4Regex.test(breakUrl)) {
            updateErrors({ breakUrl: "URL must be either an M3U8 or MP4 format." });
            combinedRef.current['breakUrl'].focus();
        } else {
            handleAddVideo({ type: 'break', title: 'Break', duration: '00:02:00', url: playoutData?.play_out?.breakUrl })
            updateUI({ openBreakModal: false });
            updatePlayout({ breakUrl: "" });
        }
    }

    const handleBreakUrlClose = async () => {
        updateUI({ openBreakModal: false });
        updateErrors({ breakUrl: "" });
        updatePlayout({ breakUrl: "" });
    }

    const formatDurationInput = (value) => {
        const digitsOnly = value.replace(/\D/g, '');

        if (digitsOnly.length === 0) return '';

        const paddedDigits = digitsOnly.slice(0, 6).padStart(6, '0');

        const hours = paddedDigits.slice(0, 2);
        const minutes = paddedDigits.slice(2, 4);
        const seconds = paddedDigits.slice(4, 6);

        return `${hours}:${minutes}:${seconds}`;
    };

    const validateDurationFormat = (duration) => {
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
        return regex.test(duration);
    };

    const handleProgramFormChange = (e) => {
        const { name, value } = e.target;
        let processedValue = value;

        if (name === 'duration') {
            if (value.length <= 8 && !value.includes(':')) {
                processedValue = formatDurationInput(value);
            } else if (value.includes(':')) {
                const parts = value.split(':');
                if (parts.length <= 3) {
                    processedValue = value;
                }
            }
        }

        setState(prev => ({
            ...prev,
            programForm: {
                ...prev.programForm,
                [name]: processedValue
            }
        }));

        const errorKey = name === 'name' ? 'programName' :
            name === 'duration' ? 'programDuration' :
                name === 'url' ? 'programUrl' : name;
        updateErrors({ [errorKey]: '' });
    };

    const handleDurationBlur = (e) => {
        const { value } = e.target;
        if (value && !value.includes(':')) {
            // If user entered only digits, format it properly
            const formattedValue = formatDurationInput(value);
            setState(prev => ({
                ...prev,
                programForm: {
                    ...prev.programForm,
                    duration: formattedValue
                }
            }));
        }
    };

    const handleProgramSubmit = async () => {
        const { name, duration, url } = programForm;

        let hasErrors = false;
        const errors = {};

        if (!name.trim()) {
            errors.programName = "Program name cannot be empty.";
            hasErrors = true;
        }

        if (!duration) {
            errors.programDuration = "Duration cannot be empty.";
            hasErrors = true;
        } else if (!validateDurationFormat(duration)) {
            errors.programDuration = "Duration must be in HH:MM:SS format (e.g., 00:05:00).";
            hasErrors = true;
        } else {
            if (duration === '00:00:00') {
                errors.programDuration = "Duration cannot be zero.";
                hasErrors = true;
            }
        }

        if (!url.trim()) {
            errors.programUrl = "URL cannot be empty.";
            hasErrors = true;
        } else {
            const m3u8Regex = /\.m3u8$/i;
            const mp4Regex = /\.mp4$/i;
            if (!m3u8Regex.test(url) && !mp4Regex.test(url)) {
                errors.programUrl = "URL must be either an M3U8 or MP4 format.";
                hasErrors = true;
            }
        }

        if (hasErrors) {
            updateErrors(errors);
            return;
        }

        handleAddVideo({
            type: 'program',
            title: name,
            duration: duration,
            url: url
        });

        updateUI({ openProgramModal: false });
        setState(prev => ({
            ...prev,
            programForm: {
                name: "",
                duration: "00:05:00",
                url: ""
            }
        }));
        updateErrors({ programName: '', programDuration: '', programUrl: '' });
    };

    const isValidRtmpUrl = (url) => {
        const regex = /^rtmp:\/\/([a-z0-9\-]+\.)+[a-z0-9\-]+(:[0-9]+)?(\/[a-z0-9\-._~%!$&'()*+,;=:@]+)*$/i;
        return regex.test(url) && url.length <= 512;
    };

    const isValidHlsUrl = (url) => {
        const regex = /^https:\/\/([a-z0-9\-]+\.)+[a-z0-9\-]+(:[0-9]+)?(\/[a-z0-9\-._~%!$&'()*+,;=:@]+)*$/i;
        return regex.test(url) && url.length <= 512;
    };

    const RTMPCreateValid = () => {
        let formIsValid = true;

        if (!newRTMP?.title) {
            updateErrors({ title: "Please enter a title" });
            combinedRef.current?.title?.focus();
            formIsValid = false;
        }

        if (!isRTMPCustomPlatform) {
            if (!newRTMP?.stream_key) {
                updateErrors({ stream_key: "Please enter your stream key" });
                combinedRef.current?.stream_key?.focus();
                formIsValid = false;
            }
        } else {
            if (!newRTMP?.rtmp_url) {
                updateErrors({ rtmp_url: "RTMP URL cannot be empty" });
                combinedRef.current?.rtmp_url?.focus();
                formIsValid = false;
            }

            if (!newRTMP?.hls_url) {
                updateErrors({ hls_url: "HLS URL cannot be empty" });
                combinedRef.current?.hls_url?.focus();
                formIsValid = false;
            } else if (!isValidHlsUrl(newRTMP.hls_url)) {
                updateErrors({ hls_url: "Please enter a valid HTTPS URL (e.g., https://example.com/stream.m3u8)" });
                combinedRef.current?.hls_url?.focus();
                formIsValid = false;
            } else if (newRTMP.hls_url.length > 512) {
                updateErrors({ hls_url: "HLS URL must be less than 512 characters" });
                combinedRef.current?.hls_url?.focus();
                formIsValid = false;
            }
        }
        return formIsValid;
    }

    const handleRTMPSubmit = async () => {
        if (RTMPCreateValid()) {

            try {

                const response = await fetchRequest({ method: "POST", url: RTMPStoreApi, data: newRTMP })
                if (response?.status) {
                    toast.success(response?.message)
                    setState(prev => ({
                        ...prev,

                        playout: {
                            ...prev.playout,

                            rtmpOptions: [
                                ...(prev.playout.rtmpOptions || []),
                                {
                                    label: response.data.title,
                                    value: response.data.id
                                }
                            ],
                            rtmp_url: [
                                ...(prev.playout.rtmp_url || []),
                                {
                                    label: response.data.title,
                                    value: response.data.id
                                }
                            ],

                            play_out: {
                                ...prev.playout.play_out,
                                destination_rtmp: [
                                    ...(prev.playout.play_out?.destination_rtmp || []),
                                    response.data.id
                                ]
                            }
                        },

                        newRTMP: { platform: 'custom', source_type: '', title: '', rtmp_url: '', hls_url: '', watch_youtube_url: '', stream_key: '', custom_rtmp_base: '' },
                        editBaseUrl: false
                    }));

                }

            } catch (error) {
                console.error(error?.message);
                toast.error(error?.message)

            } finally {
                updateUI({ openRTMPModal: false });
            }
        }

    }

    const handleProgramModalClose = () => {
        updateUI({ openProgramModal: false, openVideoUploadModal: false, openRTMPModal: false });
        setState(prev => ({
            ...prev,
            programForm: {
                name: "",
                duration: "00:05:00",
                url: ""
            }
        }));
        updateErrors({ programName: '', programDuration: '', programUrl: '' });
    };

    const handleLibraryChange = async (e) => {
        const files = e.target.files;

        const allowedTypes = /video\/(mp4|x-matroska|webm|quicktime|avi)/;

        if (!allowedTypes) {
            toast.error(`Unsupported upload type: video`);
            e.target.value = '';
            return;
        }
        for (let file of files) {
            if (!allowedTypes.test(file.type)) {
                toast.error(`Unsupported file format: ${file.name}`);
                e.target.value = '';
                return;
            }
        }

        if (!files?.length) return;

        const { site_storage_limit, site_storage_memory } = storageSetting;

        // Convert storage limit to bytes
        const memoryUnits = {
            MB: 1024 ** 2,
            GB: 1024 ** 3,
            TB: 1024 ** 4
        };

        const unitMultiplier = memoryUnits[site_storage_memory];
        if (!unitMultiplier) {
            alert(`Invalid storage unit: ${site_storage_memory}`);
            return;
        }

        const byteLimit = site_storage_limit * unitMultiplier;

        // Calculate total file size
        const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);

        if (totalSize > byteLimit) {
            alert(`Upload exceeds limit: ${site_storage_limit} ${site_storage_memory}`);
            e.target.value = null; // Reset file input
            return;
        }

        // Proceed with upload
        handleFileChangeProvider(e, `${videoApi}?upload_type=video`, "library", {}, "playout", videoFetch)
        e.target.value = null; // Reset file input again
        updateUI({ openVideoUploadModal: false });
    };

    const hlsSignalChecker = async () => {

        const hlsUrl = playoutData?.play_out?.hls_url
        try {
            await fetchRequest({
                method: 'POST',
                url: `${hlsSignalApi}`,
                data: { "hls_url": hlsUrl },
            })
                .then(response => {
                    if (response?.status) {
                        const isActive = response?.is_active
                        updateSettings({ hlsSignal: isActive });
                    }
                })
                .catch((err) => {
                    // console.log("Hls Url isActive: " + err );
                    updateSettings({ hlsSignal: false });
                })
        } catch (error) {
            // console.log("Hls Url try catch: " + error );
        }
    }

    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };

    const fetchData = async () => {
        updateUI({ loading: true });
        updateState({ playout: { data: "", response_loading: true, response_error: "", response_status: false } });

        try {
            // Fetch all required data in parallel
            const [editResponse, createResponse, labelResponse] = await Promise.all([
                fetchRequest({ method: 'GET', url: editApi, data: {} }),
                axios.get(`${process.env.REACT_APP_Baseurl}/admin/playout/create`, { headers }),
                axios.get(labelApi, { headers })
            ]);

            // Process edit response
            if (editResponse?.status) {
                const updatedData = { ...editResponse.data };
                updatedData.rtmpOptions = updatedData?.rtmp_url
                updatedData.play_out.destination_rtmp = Array.isArray(updatedData?.play_out?.destination_rtmp) ? updatedData?.play_out?.destination_rtmp : [updatedData?.play_out?.destination_rtmp]
                updatedData.play_out.category_id = Array.isArray(updatedData?.play_out?.category_id) ? updatedData?.play_out?.category_id : []
                updatedData.livestream_category = updatedData?.livestream_category || createResponse?.data?.data?.livestream_category || []
                updatedData.substitute_names = updatedData?.substitute?.map(item => ({ name: item?.title, value: item?.id }));

                // Set first date
                // status 1 = live, status 2 = scheduled (awaiting start)
                // Both must show the actual scheduled start time, not the current time.
                // Only status 0 (not yet scheduled) should default to now.
                let localISOTime;
                const _status = Number(updatedData?.play_out?.streaming_status);
                const scheduledList = Array.isArray(updatedData.Scheduled_list) ? updatedData.Scheduled_list : [];
                const visibleScheduledList = _status === 0 ? removePastScheduledContents(scheduledList) : scheduledList;
                updatedData.Scheduled_list = visibleScheduledList;
                const _hasSchedule = visibleScheduledList.length > 0;
                const firstStart = getScheduledItemStartDate(visibleScheduledList[0]);

                if (_hasSchedule && firstStart) {
                    localISOTime = new Date(firstStart.getTime() - firstStart.getTimezoneOffset() * 60000)
                        .toISOString().slice(0, 16);
                } else {
                    const now = new Date();
                    now.setSeconds(0, 0);
                    localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                        .toISOString().slice(0, 16);
                }

                // Set additional data from edit response
                setFeatured(updatedData?.play_out?.retain_value || 0);
                setDestination(updatedData.livestream || []);
                console.log(`updatedData.Videos ${JSON.stringify(updatedData.Videos, null, 2)}`);

                setVideos(updatedData.Videos || []);
                setPayoutsFile(updatedData.play_out || {});
                setPayoutsFilelivelist(visibleScheduledList);

                // Convert scheduled contents
                const initialContents = visibleScheduledList?.map(item => ({
                    startTime: new Date(item?.start_time),
                    endTime: new Date(item.end_time),
                    duration: parseDuration(item.duration),
                    content: item.title || (item.type === 'live' ? 'Live Stream' : 'Video'),
                    video_id: item.video_id,
                    live_stream_id: item.live_stream_id,
                    type: item.type,
                    url: item.url,
                    library_tag: item.library_tag,
                    isNewQueueItem: false
                })) || [];
                updateScheduledContents(initialContents);

                const liveOnlyList = visibleScheduledList?.filter(item => item.type === "live") || [];
                setSelectedLivedata(liveOnlyList);

                // Check HLS signal if URL exists
                const hlsUrl = updatedData?.play_out?.hls_url;
                if (hlsUrl) {
                    try {
                        const hlsCheck = await axios.post(`${process.env.REACT_APP_Baseurl}/api/check-hls-signal`, { hls_url: hlsUrl });
                        const isActive = hlsCheck?.data?.is_active === true;
                        setIsLive(isActive);
                        updateSettings({ hlsSignal: isActive });
                    } catch (hlsError) {
                        setIsLive(false);
                        updateSettings({ hlsSignal: false });
                    }
                }

                updateSettings({ firstDate: localISOTime });
                updateNewsTickerSettings({ newsTickerSettings: updatedData?.newsStickerSetting })
                updateNewsTickerContents({ newsTickerContents: updatedData?.newsTickerContents })
                updateState({ playout: { ...updatedData, response_loading: false, response_error: "", response_status: true } });

                setRegionOption(multiSelectLabel(updatedData?.regions || [], 'id', 'name'));
                setSelectedRegions(multiSelectLabel(updatedData?.Selected_Regions || [], 'id', 'name'));
            }

            // Process create response (for playout types)
            if (createResponse?.status === 200) {
                setPlayoutType(createResponse.data.data.playout_types || []);
            }

            // Process label response
            if (labelResponse?.data?.label_management) {
                updateState({ labelDisplay: labelResponse.data.label_management });
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            updateState({ playout: { data: "", response_loading: false, response_error: error?.response?.data?.message || error?.message, response_status: false } });
        } finally {
            updateUI({ loading: false });
        }
    };

    const videoFetch = async () => {
        try {
            updateUI({ vodLoading: true });
            const response = await fetchRequest({ method: 'GET', url: videoIndexApi })

            if (response?.status) {
                setVideos(response.data || []);
            }
        } catch (error) {
            console.error(error?.message);
        } finally {
            updateUI({ vodLoading: false });
        }
    }
    useEffect(async () => {
        await fetchData()
    }, []);

    useEffect(() => {
        if (!playoutData?.play_out) return;

        if (!playoutData?.play_out.remaining_time_to_start) return;

        const timer = setTimeout(() => {
            fetchData()
        }, playoutData?.play_out.remaining_time_to_start);

        return () => clearTimeout(timer);
    }, [playoutData?.play_out?.remaining_time_to_start]);

    const scheduleNextStatusCheck = (remainingSeconds) => {
        window.streamTimer = setTimeout(() => {
            fetchData();
        }, remainingSeconds);
    };

    const newsContentValue = newsTickerContents.some(item => Object.values(item).some(value => value?.trim() !== "")) || null;

    // Additional state variables for component functionality
    const [advanced, setAdvanced] = useState(false);
    const [selectedType, setSelectedType] = useState("1");
    const now = new Date();
    const formattedNow = now.toISOString().slice(0, 16);
    const [streamName, setStreamName] = useState("");
    const [SelectedPlayout, setSelectedPlayout] = useState("Schedule");
    const [playoutType, setPlayoutType] = useState([]);
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showDisableModal, setShowDisableModal] = useState(false);
    const [featured, setFeatured] = useState(0);
    const [payoutsFilelivelist, setPayoutsFilelivelist] = useState([]);
    const [hlsUrl, sethlsUrl] = useState("");
    const [singleProgramList, setSingleProgramList] = useState([]);

    // Live clock — ticks every second to keep the active-row highlight current.
    // Only runs while the playout is streaming (streaming_status === 1).
    const [liveNow, setLiveNow] = useState(new Date());

    const [videoJsOptions, setVideoJsOptions] = useState(null);

    // Fetch API data on component mount

    const [payoutsFile, setPayoutsFile] = useState({
        id: "",
        name: "",
        status: "",
        playout_types: "",
        image: "",
        player_image: "",
    });
    const [destination, setDestination] = useState([]);
    const [videos, setVideos] = useState([]);
    const [regionOption, setRegionOption] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };
    const [selectedHours, setSelectedHours] = useState("00");
    const [selectedMinutes, setSelectedMinutes] = useState("00");
    const [selectedSeconds, setSelectedSeconds] = useState("00");

    const [isScheduleActive, setIsScheduleActive] = useState(false);

    const [secondDate, setSecondDate] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [videoSearchTerm, setVideoSearchTerm] = useState("");


    const formattedFirstDate = new Date(firstDate).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });


    // Filter videos
    const filteredVideos = videos?.filter(video =>
        video?.title?.toLowerCase().includes(videoSearchTerm?.toLowerCase() || '')
    );

    const filteredData = destination?.filter((item) =>
        item?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase() || '')
    );

    const [disabledDestinationIds, setDisabledDestinationIds] = useState([]);
    const [SelectedLivedata, setSelectedLivedata] = useState([]);

    useEffect(() => {
        if (SelectedLivedata?.length > 0) {
            const disabledIds = SelectedLivedata
                .filter(item => item.type === 'live' && item.live_stream_id)
                .map(item => item.live_stream_id);
            setDisabledDestinationIds(disabledIds);
        } else {
            setDisabledDestinationIds([]);
        }
    }, [SelectedLivedata]);


    const formatDuration = (seconds) => {
        const hrs = Math.floor(seconds / 3600).toString().padStart(2, "0");
        const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${hrs}:${mins}:${secs}`;
    };



    const parseDuration = (durationStr) => {
        if (!durationStr) return 0;
        const parts = durationStr.split(':');
        return (+parts[0] || 0) * 3600 + (+parts[1] || 0) * 60 + (+parts[2] || 0);
    };

    const streamingStatus = Number(playoutData?.play_out?.streaming_status);

    const scheduledProgramContents = streamingStatus === 1
        ? scheduledContents.filter((item) => !item?.isNewQueueItem)
        : scheduledContents;

    const nextQueueContents = streamingStatus === 1
        ? scheduledContents.filter((item) => item?.isNewQueueItem)
        : [];

    // Which row is currently playing? Walk through the schedule, accumulate
    // elapsed time from firstDate, and find the slot that contains liveNow.
    // Returns -1 when not live or before the first program starts.
    const activeIndex = (() => {
        if (streamingStatus !== 1 || !firstDate) return -1;
        let cursor = new Date(firstDate);
        for (let i = 0; i < scheduledProgramContents.length; i++) {
            const start = new Date(cursor);
            const end   = new Date(cursor.getTime() + scheduledProgramContents[i].duration * 1000);
            if (liveNow >= start && liveNow < end) return i;
            cursor = end;
        }
        return -1;
    })();

    const recalculateNewQueueTimings = (contents) => {
        const updatedContents = contents.map((item) => ({ ...item }));
        const firstQueueIndex = updatedContents.findIndex((item) => item?.isNewQueueItem);

        if (firstQueueIndex === -1) {
            return updatedContents;
        }

        let currentTime = firstQueueIndex > 0
            ? new Date(updatedContents[firstQueueIndex - 1]?.endTime || firstDate)
            : new Date(firstDate);

        for (let i = firstQueueIndex; i < updatedContents.length; i++) {
            if (!updatedContents[i]?.isNewQueueItem) {
                currentTime = new Date(updatedContents[i]?.endTime || currentTime);
                continue;
            }

            const startTime = new Date(currentTime);
            const endTime = new Date(startTime.getTime() + updatedContents[i].duration * 1000);

            updatedContents[i].startTime = startTime.toISOString();
            updatedContents[i].endTime = endTime.toISOString();
            currentTime = endTime;
        }

        return updatedContents;
    };

    // Handle drag and drop functionality
    const onDragEnd = (result) => {
        if (!result.destination) return;

        if (result.source.droppableId === 'next-queue-droppable') {
            const queueItems = scheduledContents.filter((item) => item?.isNewQueueItem);
            const [reorderedItem] = queueItems.splice(result.source.index, 1);
            queueItems.splice(result.destination.index, 0, reorderedItem);

            let queueIndex = 0;
            const reorderedContents = scheduledContents.map((item) =>
                item?.isNewQueueItem ? queueItems[queueIndex++] : item
            );

            updateScheduledContents(recalculateNewQueueTimings(reorderedContents));
            return;
        }

        const items = Array.from(scheduledContents);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        recalculateTimings(items);
    };

    const recalculateTimings = (items) => {
        let currentTime = new Date();
        items.forEach((item, index) => {
            if (index > 0) {
                const previousItem = items[index - 1];
                currentTime = new Date(previousItem.endTime);
            }
            item.startTime = new Date(currentTime);
            item.endTime = new Date(currentTime.getTime() + item.duration * 1000);
        });

        updateScheduledContents(items);
    };


    // Function to handle editing duration
    const handleDurationChange = (index, newDuration) => {
        const updatedContents = [...scheduledContents];

        // Validate input format (HH:mm:ss)
        const durationRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
        if (durationRegex.test(newDuration)) {
            const parsedDuration = parseDuration(newDuration);
            updatedContents[index].duration = parsedDuration; // Update duration
            recalculateTimings(updatedContents);
            updateScheduledContents(updatedContents);
        }
        // No alert, simply ignore invalid input
    };


    // Function to handle editing start time
    const handleStartTimeChange = (index, newStartTime) => {
        const updatedContents = [...scheduledContents];
        updatedContents[index].startTime = new Date(newStartTime);
        recalculateTimings(updatedContents);
    };

    const [imageLoaded, setImageLoaded] = useState(false);
    const [isLive, setIsLive] = useState(false);



    const [openPickerIndex, setOpenPickerIndex] = useState(null);


    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };


    // Explicitly set to true when adding content
    useEffect(() => {
        if (scheduledContents.length > 0) {
            setIsScheduleActive(true);
        }
    }, [scheduledContents]);

    // Tick liveNow every second so the active-row highlight moves automatically
    // as programs finish and the next one starts. Stops when not live.
    useEffect(() => {
        if (Number(playoutData?.play_out?.streaming_status) !== 1) return;
        const ticker = setInterval(() => setLiveNow(new Date()), 1000);
        return () => clearInterval(ticker);
    }, [playoutData?.play_out?.streaming_status]);

    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);

    const [selectedFile1, setSelectedFile1] = useState(null);
    const [selectedFile2, setSelectedFile2] = useState(null);


    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file) || "";
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01; // Allow for some minor floating-point precision issues
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                reject(new Error('Error loading image'));
            };
        });
    };




    const formatDateForInput = (date) => {
        if (!date) {
            return "";
        }

        const local = new Date(date);
        if (local.toString() === "Invalid Date") {
            return "";
        }

        local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
        // console.log("format time: " + local.toISOString().slice(0, 16));

        return local.toISOString().slice(0, 16);
    };


    const parseInputToLocalDate = (inputValue) => {
        // Treat the input as local time (ignore timezone)
        const now = new Date();
        const utcYear = now.getUTCFullYear();
        const utcMonth = now.getUTCMonth() + 1; // Months are zero-based
        const utcDate = now.getUTCDate();
        const utcHours = now.getUTCHours();
        const utcMinutes = now.getUTCMinutes();
        const utcSeconds = now.getUTCSeconds();
        console.log(`Current UTC Time: ${utcYear}-${utcMonth}-${utcDate} ${utcHours}:${utcMinutes}:${utcSeconds}`);

        const [datePart, timePart] = inputValue.split('T');
        const [year, month, day] = datePart.split('-');
        const [hours, minutes] = timePart.split(':');

        return new Date(year, month - 1, day, hours, minutes);
    };

    // Additional helper functions for single playout mode
    const handleAddProgram = () => {
        const newProgram = {
            title: "",
            start_time: new Date().toISOString().slice(0, 16)
        };
        setSingleProgramList(prev => [...prev, newProgram]);
    };

    const handleInputChange = (index, field, value) => {
        setSingleProgramList(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        );
    };

    const editableRef = useRef(null);

    const productTypeFromEnv = process.env.REACT_APP_DEPLOYMENT_PRODUCT_TYPE;


    let productType;

    if (productTypeFromEnv && productTypeFromEnv !== "null" && productTypeFromEnv !== "undefined") {
        productType = productTypeFromEnv;
    } else {
        productType = adminSetting?.productType;
    }

    const pageUrl = `${productType === 'playout' ? `${process.env.REACT_APP_Baseurl_Backend}/nexs-player/playout/${playoutData?.play_out?.slug}` : `${process.env.REACT_APP_Baseurl_Frontend}/player/playout/${playoutData?.play_out?.slug}`}`;

    const userPermission = Number(userDetails?.permission_id)

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    function CategoryMultiSelect({ options, value = [], onChange }) {
        const [open, setOpen] = React.useState(false);

        useEffect(() => {
            function handleClickOutside(event) {
                const box = combinedRef.current.category_checkbox;
                if (box && !box.contains(event.target)) {
                    setOpen(false);
                }
            }

            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }, []);

        const toggle = (selectedId) => {
            if (value.includes(selectedId)) {
                onChange(value.filter((item) => item !== selectedId));
                return;
            }

            onChange([...value, selectedId]);
        };

        return (
            <div ref={(el) => (combinedRef.current.category_checkbox = el)} style={{ position: "relative" }}>
                <div
                    ref={(el) => (combinedRef.current.category_id = el)}
                    className="custom-input-border custom-input theme-text-color cursor-pointer mb-3"
                    tabIndex={0}
                    role="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen((prevOpen) => !prevOpen);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setOpen((prevOpen) => !prevOpen);
                        }
                    }}
                >
                    {value.length ? `${value.length} categories selected` : "Choose categories"}
                </div>

                {open && (
                    <div
                        className="theme-bg-color theme-text-color"
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            zIndex: 50,
                            maxHeight: "320px",
                            overflowY: "auto",
                            border: "1px solid rgba(0, 0, 0, 0.12)",
                            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.12)",
                            borderRadius: "8px",
                            padding: "8px 0"
                        }}
                    >
                        <TreeCheckbox
                            options={options}
                            selected={value}
                            onToggle={toggle}
                            level={0}
                        />
                    </div>
                )}
            </div>
        );
    }

    function TreeCheckbox({ options, selected, onToggle, level }) {
        if (!options || !Array.isArray(options)) return null;

        return (
            <ul className="mb-0 ps-0" style={{ listStyle: "none" }}>
                {options.map((item) => (
                    <li key={item.id}>
                        <label
                            className="custom-input theme-text-color d-flex align-items-center gap-2 py-1 cursor-pointer"
                            style={{ paddingLeft: `${(level * 16) + 12}px` }}
                        >
                            <input
                                type="checkbox"
                                checked={selected.includes(item.id)}
                                onChange={() => onToggle(item.id)}
                            />
                            {item.name}
                        </label>

                        {item.sub_category?.length > 0 && (
                            <TreeCheckbox
                                options={item.sub_category}
                                selected={selected}
                                onToggle={onToggle}
                                level={level + 1}
                            />
                        )}
                        {item.sub_categories?.length > 0 && (
                            <TreeCheckbox
                                options={item.sub_categories}
                                selected={selected}
                                onToggle={onToggle}
                                level={level + 1}
                            />
                        )}
                    </li>
                ))}
            </ul>
        );
    }


    return (

        <>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation id="playout-backbtn" path="/tv-playouts" text="Back" />
            <FormContainer className={`justify-content-between`}>
                <LeftWrapper>
                    <MessageHeading text={playoutData?.play_out?.name} className="admin-title pb-sm-0  text-md-start" />
                </LeftWrapper>
                <RightWrapper className={'text-end'}>
                    {/* <AdminCustomButton saveMethod={handleScrollToAnalytics} className={`m-2`} saveText={`Go to Analytics`}></AdminCustomButton> */}
                    {isStreaming && <Link className={`m-2 theme-button-text-color admin-button-text  rounded-3  py-2 px-3 button-bg-color`} to={`${process.env.REACT_APP_Baseurl_Frontend}/player/playout/${playoutData?.play_out?.slug}`}>Preview</Link>}
                    <AdminCustomButton saveMethod={handleStore} saveText={"update"} />
                </RightWrapper>
            </FormContainer>



            {Number(playoutData?.play_out?.streaming_status) === 1 &&
                <>
                    <div className="d-flex justify-content-end mx-3 mb-2">
                        <button id="reloadButton" className="bg-transparent custom-tool-tip-parent reloadButton theme-text-color px-2 border border-2 rounded-circle theme-border-color" onClick={() => setPlayerKey(prev => prev + 1)}>
                            <RxReload style={{ width: "18px", height: "15px" }} />
                            <AdminTooltip text="Reload Player" top="-35px" className="d-none custom-tool-tip" />
                        </button>
                        {/* <MessageLabel text="Reload the player" noMargin/> */}
                    </div>
                    <div className="playout-player rounded-4">
                        <NexusPlayer key={playerKey} mute controls={true} title={playoutData?.play_out?.name} player_image={playoutData?.play_out?.player_image} url={playoutData?.play_out?.hls_url} fallbackUrl1={playoutData?.play_out?.hls_url} fallbackUrl2={playoutData?.play_out?.hls_url} fallbackUrl3={playoutData?.play_out?.substituteUrl} newsTickerContents={newsTickerContents} enableNewsTicker={newsContentValue} />
                    </div>
                </>
            }
            {Number(playoutData?.play_out?.streaming_status) !== 0 &&
                <FormContainer>
                    <LeftWrapper>
                        <Wrapper className={'mt-3'}>
                            <MessageLabel text={`iframe URL`} noMargin className="mt-2" />
                            {playoutData?.play_out?.slug &&
                                (() => {

                                    const iframeHtml = `<iframe src="${pageUrl}" allow="autoplay; fullscreen" allowfullscreen sandbox="allow-scripts allow-same-origin allow-popups allow-forms"></iframe>`;
                                    return (
                                        <AdminCustomURLCopy
                                            link={iframeHtml}
                                            fieldName={""}
                                            className="copy-board-input"
                                        />
                                    );
                                })()
                            }

                            {playoutData?.play_out?.streamKey &&
                                <div>
                                    <MessageLabel text={`Player URL`} noMargin className="mt-2" />
                                    <AdminCustomURLCopy link={pageUrl} fieldName={""} className="copy-board-input" />
                                </div>
                            }

                        </Wrapper>
                    </LeftWrapper>

                    <RightWrapper>
                        <Wrapper className={'mt-3'}>
                            {playoutData?.play_out?.hls_url &&
                                <>
                                    <MessageLabel text={`HLS URL`} noMargin className="mt-2" />
                                    <AdminCustomURLCopy link={Array.isArray(playoutData?.play_out?.hls_url) ? playoutData?.play_out?.hls_url?.[0] : playoutData?.play_out?.hls_url} fieldName={""} className="copy-board-input" />
                                </>
                            }
                            {playoutData?.play_out?.streamKey &&
                                <div>
                                    <MessageLabel text={`Current stream key`} noMargin className="mt-2" />
                                    <AdminCustomURLCopy link={Array.isArray(playoutData?.play_out?.streamKey) ? playoutData?.play_out?.streamKey?.[0] : playoutData?.play_out?.streamKey} fieldName={""} className="copy-board-input" />
                                </div>
                            }

                        </Wrapper>
                    </RightWrapper>
                </FormContainer>
            }


            <FormContainer>

                {userPermission !== 5 && (
                    <>
                        <LeftWrapper>
                            <Wrapper>
                                <MessageLabel text={labelDisplay?.[0]?.title} noMargin className="ms-2 mandatorySimple" />
                                <AdminCustomInput className={`mt-2`} id="playout-title" type="text" name="name" value={playoutData?.play_out?.name} onChange={handleInput} placeHolder={"Title"} maxLength={50} ref={(el) => (combinedRef.current.name = el)} error={playoutDataError?.name} />

                                <MessageLabel text={labelDisplay?.[1]?.title} noMargin className="ms-2 mandatorySimple" />
                                <AdminCustomSelect className={`mt-2`} id="playout_types" name="playout_types" value={playoutData?.play_out?.playout_types} options={playoutData?.play_out?.types} onChange={handleInput} ref={(el) => (combinedRef.current.playout_types = el)} error={playoutDataError?.playout_types} defaultOptionName={"Select mode"} />
                                {userPermission !== 5 && (
                                    <>

                                        <div id="playout-category-selection">
                                            <MessageLabel text={"Choose category"} noMargin className="ms-2 mb-2" />
                                            <CategoryMultiSelect
                                                options={playoutData?.livestream_category || []}
                                                value={playoutData?.play_out?.category_id || []}
                                                onChange={handleCategoryChange}
                                            />
                                            {playoutDataError?.category_id && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.category_id}`} classname='errorred  d-block' /></div>)}
                                        </div>
                                        < MessageLabel text={"Description"} noMargin className="ms-2" />
                                        <AdminCustomArea id="playout-description" name="description" value={playoutData?.play_out?.description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.description = el)} placeHolder={"description"} rows={5} maxLength={"250"} />

                                        {onlyPermission?.includes(47) && (
                                            <>
                                                <MessageLabel text={"Region"} noMargin className="ms-2 mb-1 mt-2" />
                                                <MessageSubHeading text={"Add Region for the Playout below"} />
                                                <Select id="playout-region" options={regionOption} isMulti onChange={(val) => setSelectedRegions(val)} value={selectedRegions} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                                            </>
                                        )}
                                    </>
                                )}
                                <div className="d-flex justify-content-between ms-2">
                                    <MessageLabel text={labelDisplay?.[3]?.title} noMargin className="mandatorySimple" />
                                    <div className="d-flex justify-content-between align-items-center w-50">
                                        <Link to={'/site/rtmpurl'}>
                                            <span className="fw-medium ms-2" style={{ fontSize: "10px" }}>RTMP Settings</span>
                                            <CiShare1
                                                style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    strokeWidth: "1px",
                                                    marginLeft: "6px",
                                                }}
                                            />
                                        </Link>
                                        <button type="button" id="video-category-add-button" className="vjs-big-play-button rounded" onClick={() => updateUI({ openRTMPModal: true })} title="Add RTMP">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>
                                </div>
                                <div id="playout-rtmp-selector">
                                    <Select
                                        ref={(el) => (combinedRef.current.destination_rtmp = el)}
                                        options={playoutData?.rtmpOptions}
                                        isMulti
                                        name="destination_rtmp"
                                        onChange={handleMultiSelect}
                                        value={
                                            playoutData?.play_out?.destination_rtmp?.map(val =>
                                                playoutData?.rtmpOptions.find(opt => opt.value === val)
                                            ) || []
                                        }
                                        className={`custom-select-multi custom-input-border ${!playoutDataError?.destination_rtmp && 'custom-input'} custom-placeholder bg-transparent theme-text-color w-100 mb-3 ${playoutDataError?.destination_rtmp && 'custom-input-error'}`}
                                        placeholder="Select destination RTMP"
                                    />
                                </div>
                                {playoutDataError?.destination_rtmp && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.destination_rtmp}`} classname='errorred  d-block' /></div>)}

                                {/* <AdminCustomSelect className={`mt-2`} id="destination_rtmp" name="destination_rtmp" value={playoutData?.play_out?.destination_rtmp} onChange={handleInput} ref={(el) => (combinedRef.current.destination_rtmp = el)} options={playoutData?.rtmp_url} error={playoutDataError?.destination_rtmp} defaultOptionName={"Select destination RTMP"} /> */}

                                <MessageLabel text={labelDisplay?.[2]?.title} noMargin className="ms-2" />
                                <AdminCustomSelect className={`mt-2`} id="substitute_title" name="substitute_id" value={playoutData?.play_out?.substitute_id} onChange={handleInput} ref={(el) => (combinedRef.current.substitute_id = el)} options={playoutData?.substitute_names} error={playoutDataError?.substitute_id} defaultOptionName={"Select substitute video"} />

                                <div id="playout-access-selection">
                                    <MessageLabel text={'choose access'} noMargin className="ms-2" />
                                    <AdminCustomSelect className={`mt-2`} id="choose-access" name="access" value={playoutData?.play_out?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={accessOption} error={playoutDataError?.access} defaultOptionName={"Choose an user access"} />
                                </div>

                                {playoutData?.play_out?.access == 'ppv' &&
                                    <>
                                        <MessageLabel text={`Enter the PPV price`} noMargin className="ms-2 mandatorySimple" />
                                        <AdminCustomInput className={`mt-2`} id="ppv-price" type="number" name="ppv_price" value={Number(playoutData?.play_out?.ppv_price)} onChange={handleInput} placeHolder={"Enter price"} maxLength={50} ref={(el) => (combinedRef.current.ppv_price = el)} error={playoutDataError?.ppv_price} />
                                    </>
                                }

                            </Wrapper>
                        </LeftWrapper>
                        <RightWrapper id="playout-image-uploads">
                            <Wrapper>
                                <MessageLabel text={labelDisplay?.[7]?.title} />
                                <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[7]?.sub_title, 'portrait')} />
                                <AdminImageUploadZone
                                    idAttribute="playout-thumbnail-image"
                                    onChange={handleFileChange}
                                    selectedFile={coverImageFile}
                                    uploadedImage={playoutData?.play_out?.image}
                                    onDelete={handleClearSelectFile}
                                    ref={(el) => (combinedRef.current.image = el)}
                                    name="image"
                                    apiFieldName="image"
                                    orientationSlug="portrait"
                                    enableCropping={siteTheme?.enable_image_cropping === 1}
                                    id={id}
                                    error={playoutDataError?.image}
                                />
                                <MessageLabel text={labelDisplay?.[8]?.title} />
                                <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[8]?.sub_title, 'landscape')} />
                                <AdminImageUploadZone
                                    idAttribute="playout-plyer-image"
                                    onChange={handleFileChange}
                                    selectedFile={playerImageFile}
                                    uploadedImage={playoutData?.play_out?.player_image}
                                    onDelete={handleClearSelectFile}
                                    ref={(el) => (combinedRef.current.player_image = el)}
                                    name="player_image"
                                    apiFieldName="player_image"
                                    orientationSlug="landscape"
                                    enableCropping={siteTheme?.enable_image_cropping === 1}
                                    id={id}
                                    error={playoutDataError?.player_image}
                                />

                                <div id="playout-status-settings">
                                    <Wrapper noPadding className={`ms-2`}>
                                        <MessageHeading text={labelDisplay?.[4]?.title} />
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text={labelDisplay?.[5]?.title} />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="status" name="status" checked={Number(playoutData?.play_out?.status) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text={labelDisplay?.[6]?.title} />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="retain-value" name="retain_value" checked={Number(playoutData?.play_out?.retain_value) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text="Retain stream key" />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="streamkey-retain" name="streamkey_retain" checked={Number(playoutData?.play_out?.streamkey_retain) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text="Promote as advertisement" />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="is-ads" name="is_ads" checked={Number(playoutData?.play_out?.is_ads) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                    </Wrapper>
                                </div>

                            </Wrapper>
                        </RightWrapper>
                    </>
                )}

                {userPermission === 5 && (
                    <>
                        <LeftWrapper>
                            <Wrapper>
                                <MessageLabel text={labelDisplay?.[0]?.title} noMargin className="ms-2 mandatorySimple" />
                                <AdminCustomInput className={`mt-2`} id="playout-title" type="text" name="name" value={playoutData?.play_out?.name} onChange={handleInput} placeHolder={"Title"} maxLength={50} ref={(el) => (combinedRef.current.name = el)} error={playoutDataError?.name} />

                                <MessageLabel text={labelDisplay?.[1]?.title} noMargin className="ms-2 mandatorySimple" />
                                <AdminCustomSelect className={`mt-2`} id="playout_types" name="playout_types" value={playoutData?.play_out?.playout_types} options={playoutData?.play_out?.types} onChange={handleInput} ref={(el) => (combinedRef.current.playout_types = el)} error={playoutDataError?.playout_types} defaultOptionName={"Select mode"} />


                                <div id="playout-status-settings">
                                    <Wrapper noPadding className={`ms-2`}>
                                        <MessageHeading text={labelDisplay?.[4]?.title} />
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text={labelDisplay?.[6]?.title} />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="retain-value" name="retain_value" checked={Number(playoutData?.play_out?.retain_value) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text="Retain stream key" />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="streamkey-retain" name="streamkey_retain" checked={Number(playoutData?.play_out?.streamkey_retain) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 ">
                                            <div className="col-7 col-md-7 pe-2">
                                                <MessageLabel text="Promote as advertisement" />
                                            </div>
                                            <div className="col-5 col-md-5 ps-2 text-end">
                                                <AdminSwitch id="is-ads" name="is_ads" checked={Number(playoutData?.play_out?.is_ads) === 1} onChange={handleInput} />
                                            </div>
                                        </div>
                                    </Wrapper>
                                </div>
                            </Wrapper>
                        </LeftWrapper>
                        <RightWrapper id="playout-image-uploads">
                            <Wrapper>
                                <div className="d-flex justify-content-between ms-2">
                                    <MessageLabel text={labelDisplay?.[3]?.title} noMargin className="mandatorySimple" />
                                    <div className="d-flex justify-content-between align-items-center w-50">
                                        <Link to={'/site/rtmpurl'}>
                                            <span className="fw-medium ms-2" style={{ fontSize: "10px" }}>RTMP Settings</span>
                                            <CiShare1
                                                style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    strokeWidth: "1px",
                                                    marginLeft: "6px",
                                                }}
                                            />
                                        </Link>
                                        <button type="button" id="video-category-add-button" className="vjs-big-play-button rounded" onClick={() => updateUI({ openRTMPModal: true })} title="Add RTMP">
                                            < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                        </button>
                                    </div>
                                </div>
                                <div id="playout-rtmp-selector">
                                    <Select
                                        ref={(el) => (combinedRef.current.destination_rtmp = el)}
                                        options={playoutData?.rtmpOptions}
                                        isMulti
                                        name="destination_rtmp"
                                        onChange={handleMultiSelect}
                                        value={
                                            playoutData?.play_out?.destination_rtmp?.map(val =>
                                                playoutData?.rtmpOptions.find(opt => opt.value === val)
                                            ) || []
                                        }
                                        className={`custom-select-multi custom-input-border ${!playoutDataError?.destination_rtmp && 'custom-input'} custom-placeholder bg-transparent theme-text-color w-100 mb-3 ${playoutDataError?.destination_rtmp && 'custom-input-error'}`}
                                        placeholder="Select destination RTMP"
                                    />
                                </div>
                                {playoutDataError?.destination_rtmp && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.destination_rtmp}`} classname='errorred  d-block' /></div>)}

                                {/* <AdminCustomSelect className={`mt-2`} id="destination_rtmp" name="destination_rtmp" value={playoutData?.play_out?.destination_rtmp} onChange={handleInput} ref={(el) => (combinedRef.current.destination_rtmp = el)} options={playoutData?.rtmp_url} error={playoutDataError?.destination_rtmp} defaultOptionName={"Select destination RTMP"} /> */}

                                <MessageLabel text={labelDisplay?.[2]?.title} noMargin className="ms-2" />
                                <AdminCustomSelect className={`mt-2`} id="substitute_title" name="substitute_id" value={playoutData?.play_out?.substitute_id} onChange={handleInput} ref={(el) => (combinedRef.current.substitute_id = el)} options={playoutData?.substitute_names} error={playoutDataError?.substitute_id} defaultOptionName={"Select substitute video"} />

                                <div id="playout-access-selection">
                                    <MessageLabel text={'choose access'} noMargin className="ms-2" />
                                    <AdminCustomSelect className={`mt-2`} id="choose-access" name="access" value={playoutData?.play_out?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={accessOption} error={playoutDataError?.access} defaultOptionName={"Choose an user access"} />
                                </div>

                                {playoutData?.play_out?.access == 'ppv' &&
                                    <>
                                        <MessageLabel text={`Enter the PPV price`} noMargin className="ms-2 mandatorySimple" />
                                        <AdminCustomInput className={`mt-2`} id="ppv-price" type="number" name="ppv_price" value={Number(playoutData?.play_out?.ppv_price)} onChange={handleInput} placeHolder={"Enter price"} maxLength={50} ref={(el) => (combinedRef.current.ppv_price = el)} error={playoutDataError?.ppv_price} />
                                    </>
                                }

                            </Wrapper>
                        </RightWrapper>
                    </>
                )}

            </FormContainer>



            {/* <Wrapper>
                <div className={`nav-link d-flex align-items-center justify-content-between cursor-pointer`} data-bs-toggle={"collapse"} data-bs-target={"#news-ticker"} aria-expanded="false" aria-controls="news-ticker">
                    <MessageHeading padding noMargin text={'News Ticker'} />
                    <IoIosArrowDown />
                </div>

                <div id="news-ticker" className={`collapse`}>
                    <FormContainer>
                        <LeftWrapper>
                            <Wrapper noMargin>
                                <MessageLabel text={'Position'} />
                                <AdminCustomSelect name="position" value={playoutData?.play_out?.ticker_settings?.position} options={newsTickerSettings?.defaultPositions} onChange={handleInput} defaultOptionName={'Select the Position'} />
                                <MessageLabel text={'Background Color'} />
                                <div className="mt-2 overflow-hidden shadow col-3 rounded-2">
                                    <input type="color" className="rs-input form-control-lg p-0  colorPicker " id="backgroundColor" name="backgroundColor" onChange={handleInput} value={playoutData?.play_out?.ticker_settings?.backgroundColor} />
                                    <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="backgroundColor" onChange={handleInput} value={playoutData?.play_out?.ticker_settings?.backgroundColor}></input>
                                </div>
                            </Wrapper>
                        </LeftWrapper>
                        <RightWrapper>
                            <Wrapper noMargin>
                                <MessageLabel text={'Speed'} />
                                <AdminCustomSelect name="speed" value={playoutData?.play_out?.ticker_settings?.speed} options={newsTickerSettings?.defaultSpeed} onChange={handleInput} defaultOptionName={'Select the speed'} />
                                <MessageLabel text={'Gap'} />
                                <AdminCustomSelect name="gap" value={playoutData?.play_out?.ticker_settings?.gap} options={newsTickerSettings?.defaultGap} onChange={handleInput} defaultOptionName={'Select the Gap'} />
                            </Wrapper>
                        </RightWrapper>
                    </FormContainer>
                    <Wrapper noPadding>
                        {playoutData?.play_out?.ticker_settings?.position !== 'both' ? (
                            <Wrapper>
                                <MessageLabel text={"News Contents"} />
                                <FormContainer>
                                    <LeftWrapper custom className={"d-flex col-11 col-md-11 px-2 ps-md-0"}>
                                        <LeftWrapper custom className={"col-12 col-md-3 px-2 ps-md-0"}>
                                            <MessageSubHeading className={"px-2"} text={"Add the Intro Text"} />
                                        </LeftWrapper>
                                        <RightWrapper custom className={"col-12 col-md-4 px-2 ps-md-0"}>
                                            <MessageSubHeading className={"px-2"} text={"Add the Heading"} />
                                        </RightWrapper>
                                        <RightWrapper custom className={"col-md-5 col-12 px-2 ps-md-0"}>
                                            <MessageSubHeading className={"px-2"} text={"Add the News"} />
                                        </RightWrapper>
                                    </LeftWrapper>
                                </FormContainer>
                                {newsTickerContents?.map((item, index) => (
                                    <FormContainer key={index}>
                                        <LeftWrapper custom className={"d-flex col-11 col-md-11 px-2 ps-md-0"}>
                                            <LeftWrapper custom className={"col-12 col-md-3 px-2 ps-md-0"}>
                                                <AdminCustomInput type="text" name="intro_text" value={item?.intro_text} onChange={(e) => newsTickerHandleInput(e, index)} placeHolder="Like 'Breaking News'" />
                                            </LeftWrapper>
                                            <RightWrapper custom className={"col-12 col-md-4 px-2 ps-md-0"}>
                                                <AdminCustomInput type="text" name="heading_text" value={item?.heading_text} onChange={(e) => newsTickerHandleInput(e, index)} placeHolder="Weather Alert Today" />
                                            </RightWrapper>
                                            <RightWrapper custom className={"col-md-5 col-12 px-2 ps-md-0"}>
                                                <AdminCustomInput type="text" name="news_text" value={item?.news_text} onChange={(e) => newsTickerHandleInput(e, index)} placeHolder="Heavy rain expected in coastal areas..." />
                                            </RightWrapper>
                                        </LeftWrapper>
                                        <RightWrapper custom className={"col-1 col-md-1 px-2 ps-md-0"}>
                                            <FormContainer className={"align-items-center justify-content-between h-100"}>
                                                <FaPlus className="cursor-pointer" onClick={() => newsTickerHandleClick("add", index)} />
                                                <FaTimes className="cursor-pointer" onClick={() => newsTickerHandleClick("remove", index)} />
                                            </FormContainer>
                                        </RightWrapper>
                                    </FormContainer>
                                ))}
                            </Wrapper>
                        ) : (
                            <Wrapper></Wrapper>
                        )}
                    </Wrapper>
                </div>
            </Wrapper> */}

            {(playoutData?.play_out?.playout_types === 'schedule' || playoutData?.play_out?.playout_types === 'loop') && (
                <>
                    <MessageLabel noMargin text={labelDisplay?.[41]?.title ?? "Schedule start time"} />
                    <FormContainer>
                        <LeftWrapper custom className={'left-programs-list col-md-4 col-12 pr-2 mb-4'}>
                            <input
                                type="datetime-local"
                                name="date"
                                id="Schedule-date"
                                className="rs-input form-control-lg"
                                // min/max only relevant when the user can actually edit the field (status 0)
                                min={streamingStatus === 0 ? new Date(new Date().setSeconds(0, 0)).toISOString().slice(0, 16) : undefined}
                                max={streamingStatus === 0 ? new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16) : undefined}
                                value={formatDateForInput(firstDate)}
                                readOnly={streamingStatus !== 0}
                                onChange={(e) => { inputStartDateTimeChange(e.target.value) }}
                                style={{ height: "50px", cursor: streamingStatus !== 0 ? 'default' : 'auto' }}
                                ref={(el) => (combinedRef.current.date = el)}
                            />
                            {playoutDataError?.date && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.date}`} classname='errorred  d-block' /></div>)}
                            <Wrapper id='playout-add-vod-btn-0' noMargin={false}>
                                <ul className="nav nav-underline live-vod" id="pills-tab" role="tablist">
                                    {/* <li className="nav-item" role="presentation">
                                        <button className="nav-link active live-custom" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-livestream" type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                                            {labelDisplay?.[9]?.title}
                                        </button>
                                    </li> */}
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active vod-custom" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-videos" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
                                            {labelDisplay?.[9]?.sub_title}
                                        </button>
                                    </li>
                                </ul>

                                <div className="tab-content">
                                    <div className="tab-pane fade" id="pills-livestream" role="tabpanel" aria-labelledby="pills-home-tab">
                                        <table className="table video-table">
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2} className="p-0 pb-2">
                                                        <div className="search-container">
                                                            <FaSearch className="search-icon" />
                                                            <input type='search' id="video-search-input-livestream" placeholder='Search' name="title" className='table-search search-input' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                                        </div>
                                                    </td>
                                                </tr>

                                                {/* Breaks Row */}
                                                <tr className="breaks-container rounded-3 position-relative" style={{ pointerEvents: Number(playoutData?.play_out?.streaming_status) === 1 ? 'none' : 'auto', opacity: Number(playoutData?.play_out?.streaming_status) === 1 ? 0.6 : 1 }}>
                                                    <td className="break-wrapper p-0">
                                                        <span className="ms-1">{labelDisplay?.[10]?.title}</span>

                                                        {/* Breaks Tooltip */}
                                                        <div data-tooltip-id="break-tooltip" className="ms-1 cursor-pointer">
                                                            <FaQuestionCircle size={15} className="text-gray-500" />
                                                        </div>

                                                        <Tooltip id="break-tooltip" effect="solid" place="bottom" globalEvents={true} className="tooltip-break-content">
                                                            <p>{labelDisplay?.[10]?.sub_title}</p>
                                                        </Tooltip>
                                                    </td>
                                                    <td className="p-0">
                                                        <div>
                                                            {/* <CiSquarePlus className="break-add-icon" onClick={() => handleAddVideo({ type: 'break', title: 'Break', duration: '00:02:00', url: null })} /> */}
                                                            <CiSquarePlus className="break-add-icon" onClick={() => updateUI({ openBreakModal: true })} />
                                                            {openBreakModal &&
                                                                <div className={`theme-bg-color p-0 rounded-2 position-absolute breakUrl-input`}>
                                                                    <div className="d-flex align-items-center p-2 gap-2 shadow">
                                                                        <AdminCustomInput type="text" name={`breakUrl`} onChange={handleInput} value={playoutData?.play_out?.breakUrl} placeHolder={`Paste the URL here`} ref={(el) => (combinedRef.current.breakUrl = el)} error={playoutDataError?.breakUrl} ></AdminCustomInput>
                                                                        <AdminCustomButton className={`break-check`} saveText={<FaCheck />} saveMethod={() => handleUrlBreak()}></AdminCustomButton>
                                                                        <AdminCustomButton className={`break-cancel`} saveText={<FaTimes />} saveMethod={() => handleBreakUrlClose()}></AdminCustomButton>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>

                                                <div style={{ maxHeight: '320px', overflowY: 'auto', pointerEvents: Number(playoutData?.play_out?.streaming_status) === 1 ? 'none' : 'auto', opacity: Number(playoutData?.play_out?.streaming_status) === 1 ? 0.6 : 1 }}>

                                                </div>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="tab-pane fade show active" id="pills-videos" role="tabpanel" aria-labelledby="pills-profile-tab">
                                        {vodLoading ? <Defaultloadinggif /> :
                                            <table className="table video-table">
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={2} className="p-0 pb-2">
                                                            <div className="search-container">
                                                                <FaSearch className="search-icon" />
                                                                <input type='search' id="video-search-input-vod" placeholder='Search' name="title" className='table-search search-input' value={videoSearchTerm} onChange={(e) => setVideoSearchTerm(e.target.value)} />
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {/* Breaks Row */}
                                                    <tr className="breaks-container rounded-3 position-relative" style={{ pointerEvents: Number(playoutData?.play_out?.streaming_status) === 1 ? 'none' : 'auto', opacity: Number(playoutData?.play_out?.streaming_status) === 1 ? 0.6 : 1 }}>
                                                        <td className="break-wrapper p-0">
                                                            <span className="ms-1">{labelDisplay?.[10]?.title}</span>

                                                            <div data-tooltip-id="break-tooltip" className="ms-1 cursor-pointer">
                                                                <FaQuestionCircle size={15} className="text-gray-500" />
                                                            </div>

                                                            <Tooltip id="break-tooltip" effect="solid" place="bottom" globalEvents={true} className="tooltip-break-content">
                                                                <p>{labelDisplay?.[10]?.sub_title}</p>
                                                            </Tooltip>
                                                        </td>

                                                        <td className="p-0">
                                                            <div>
                                                                <CiSquarePlus className="break-add-icon" onClick={() => updateUI({ openBreakModal: true })} />
                                                                {openBreakModal &&
                                                                    <div className={`theme-bg-color p-0 rounded-2 position-absolute breakUrl-input`}>
                                                                        <div className="d-flex align-items-center p-2 gap-2 shadow">
                                                                            <AdminCustomInput type="text" name={`breakUrl`} onChange={handleInput} value={playoutData?.play_out?.breakUrl} placeHolder={`Paste the URL here`} ref={(el) => (combinedRef.current.breakUrl = el)} error={playoutDataError?.breakUrl} ></AdminCustomInput>
                                                                            <AdminCustomButton className={`break-check`} saveText={<FaCheck />} saveMethod={() => handleUrlBreak()}></AdminCustomButton>
                                                                            <AdminCustomButton className={`break-cancel`} saveText={<FaTimes />} saveMethod={() => updateUI({ openBreakModal: false })}></AdminCustomButton>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </td>

                                                    </tr>

                                                    <div className="playout-video-list-scroll">
                                                        <table className="table mb-0">
                                                            <tbody>
                                                                {filteredVideos?.map((item) => (
                                                                    <tr
                                                                        key={item.id}
                                                                        className="video-container rounded-3"
                                                                        onClick={() => handleAddVideo({ ...item, type: item?.uploaded_type !== 'site_storage' ? 'program' : 'video', video_id: item?.id })}
                                                                    >
                                                                        <td className="videos-wrapper p-0" style={{ flex: 1, minWidth: 0 }}>
                                                                            <div className="playout-video-info">
                                                                                <span
                                                                                    className="playout-video-title theme-text-color"
                                                                                    data-tooltip-id="playout-video-title-tip"
                                                                                    data-tooltip-content={item?.title || ''}
                                                                                >
                                                                                    {item?.title && item.title.length > 22
                                                                                        ? `${item.title.substring(0, 22)}…`
                                                                                        : item?.title || '—'}
                                                                                </span>

                                                                                {/* Meta pills — library tag + duration */}
                                                                                <div className="playout-video-meta">
                                                                                    {item?.library_tag && (
                                                                                        <span
                                                                                            className="playout-meta-pill playout-meta-library"
                                                                                            title={item.library_tag}
                                                                                        >
                                                                                            {item.library_tag.length > 16
                                                                                                ? `${item.library_tag.substring(0, 16)}…`
                                                                                                : item.library_tag}
                                                                                        </span>
                                                                                    )}
                                                                                    {item?.duration && (
                                                                                        <span className="playout-meta-pill playout-meta-duration">
                                                                                            {item.duration}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </td>

                                                                        {/* Add icon — isolated so its click doesn't bubble to the row */}
                                                                        <td className="videos-wrapper p-0" style={{ width: '32px', flexShrink: 0 }}>
                                                                            <CiSquarePlus
                                                                                className="playout-video-add-btn"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleAddVideo({ ...item, type: 'video', video_id: item?.id });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>

                                                        {/* Single shared tooltip — content set per item via data-tooltip-content */}
                                                        <Tooltip
                                                            id="playout-video-title-tip"
                                                            place="right"
                                                            className="playout-video-title-tooltip"
                                                        />
                                                    </div>

                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                </div>
                            </Wrapper>
                        </LeftWrapper>

                        <RightWrapper id="playout-scheduled-programs" custom className={`col-md-8 col-12 pl-2`}>
                            <Wrapper id="playout-program-list-container">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5>Scheduled Programs</h5>
                                    <div id="playout-add-content-btns" className="d-flex gap-2">
                                        <AdminCustomButton id="playout-upload-video-btn" className="btn-sm" saveText="Upload Video" saveMethod={() => updateUI({ openVideoUploadModal: true })} />
                                        <AdminCustomButton id="playout-add-custom-program-btn" className="btn-sm" saveText="Add Custom Program" saveMethod={() => updateUI({ openProgramModal: true })} />
                                    </div>
                                </div>
                                <div className="editplayouttdtd" style={{ opacity: Number(playoutData?.play_out?.streaming_status) === 1 ? 0.6 : 1 }}>
                                    {scheduledProgramContents.length > 0 ? (
                                        <div className="editplayouttdtd">
                                            <DragDropContext disabled={Number(playoutData?.play_out?.streaming_status) === 1} onDragEnd={onDragEnd}>
                                                <Droppable isDropDisabled={Number(playoutData?.play_out?.streaming_status) === 1} disabled={Number(playoutData?.play_out?.streaming_status) === 1} droppableId="droppable">
                                                    {(provided) => (
                                                        <div className="content-lists" style={{ overflowX: "auto", width: "100%" }}>
                                                            <Table {...provided.droppableProps} ref={provided.innerRef}>
                                                                <thead>
                                                                    <tr className="title">
                                                                        <th>{labelDisplay?.[11]?.title}</th>
                                                                        <th>{labelDisplay?.[12]?.title}</th>
                                                                        <th>{labelDisplay?.[13]?.title}</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {scheduledProgramContents.map((video, index) => {
                                                                        const scheduledIndex = scheduledContents.findIndex((item) => item === video);
                                                                        const destinationErrorKey = `destinationValid-${scheduledIndex === -1 ? index : scheduledIndex}`;
                                                                        const durationErrorKey = `scheduleDuration-${scheduledIndex === -1 ? index : scheduledIndex}`;
                                                                        // Calculate times based on previous video
                                                                        const prevEndTime = index > 0 ? scheduledProgramContents[index - 1].endTime : firstDate;
                                                                        const startTime = new Date(prevEndTime);
                                                                        const endTime = new Date(startTime.getTime() + (video.duration * 1000));

                                                                        // Update video with calculated times
                                                                        const videoWithTimes = {
                                                                            ...video,
                                                                            startTime,
                                                                            endTime
                                                                        };

                                                                        return (
                                                                            <Draggable isDragDisabled={streamingStatus !== 0} key={`video-${index}`} draggableId={`video-${index}`} index={index}>
                                                                                {(provided) => (
                                                                                    <tr
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                        className={index === activeIndex ? 'playout-row-active' : ''}
                                                                                    >
                                                                                        <td className={`${playoutDataError?.[destinationErrorKey] ? "custom-border-error" : ''}`} name={destinationErrorKey} ref={(el) => { if (combinedRef.current) { combinedRef.current[destinationErrorKey] = el; } }}>
                                                                                            <div className="d-flex flex-column">
                                                                                                {/* Title row — inline with NOW badge when this program is active */}
                                                                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                                                    <span>{(videoWithTimes?.content && videoWithTimes.content.length > 20 ? `${videoWithTimes?.content.substring(0, 20)}...` : videoWithTimes?.content) || (videoWithTimes.type === 'live' ? 'Live Stream' : 'Video')}</span>
                                                                                                    {index === activeIndex && (
                                                                                                        <span className="playout-now-playing-badge">
                                                                                                            <span className="playout-now-dot" />
                                                                                                            NOW
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                            {playoutDataError?.[destinationErrorKey] && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.[destinationErrorKey]}`} classname='errorred  d-block' /></div>)}
                                                                                        </td>

                                                                                        <td>
                                                                                            {/* Display in MM/DD/YYYY, HH:MM:SS format */}
                                                                                            {`${(videoWithTimes.startTime.getMonth() + 1).toString().padStart(2, '0')}/` +
                                                                                                `${videoWithTimes.startTime.getDate().toString().padStart(2, '0')}/` +
                                                                                                `${videoWithTimes.startTime.getFullYear()}, ` +
                                                                                                `${videoWithTimes.startTime.getHours().toString().padStart(2, '0')}:` +
                                                                                                `${videoWithTimes.startTime.getMinutes().toString().padStart(2, '0')}:` +
                                                                                                `${videoWithTimes.startTime.getSeconds().toString().padStart(2, '0')}`}
                                                                                        </td>
                                                                                        <td disabled={streamingStatus !== 0}>
                                                                                            <div className="d-flex duration-field">
                                                                                                <div style={{ position: "relative", display: "inline-block", pointerEvents: streamingStatus !== 0 ? 'none' : 'auto' }}>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        id={`playout-duration-input-${index}`}
                                                                                                        name={durationErrorKey}
                                                                                                        value={formatDuration(videoWithTimes.duration)}
                                                                                                        readOnly
                                                                                                        className={`custom-input ${playoutDataError?.[durationErrorKey] ? "custom-input-error" : ''}`}
                                                                                                        style={{ width: "103px", height: "30px", border: "none", cursor: "pointer" }}
                                                                                                        disabled={streamingStatus !== 0}
                                                                                                        onClick={() => {
                                                                                                            const hours = Math.floor(videoWithTimes.duration / 3600);
                                                                                                            const minutes = Math.floor((videoWithTimes.duration % 3600) / 60);
                                                                                                            const seconds = videoWithTimes.duration % 60;
                                                                                                            setSelectedHours(String(hours).padStart(2, "0"));
                                                                                                            setSelectedMinutes(String(minutes).padStart(2, "0"));
                                                                                                            setSelectedSeconds(String(seconds).padStart(2, "0"));
                                                                                                            setOpenPickerIndex(index);
                                                                                                        }}
                                                                                                        ref={(el) => {
                                                                                                            if (combinedRef.current) {
                                                                                                                combinedRef.current[durationErrorKey] = el;
                                                                                                            }
                                                                                                        }}

                                                                                                    />
                                                                                                    {playoutDataError?.[durationErrorKey] && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.[durationErrorKey]}`} classname='errorred  d-block' /></div>)}
                                                                                                    <button
                                                                                                        style={{
                                                                                                            position: "absolute",
                                                                                                            right: "5px",
                                                                                                            top: "50%",
                                                                                                            transform: "translateY(-50%)",
                                                                                                            border: "none",
                                                                                                            background: "transparent",
                                                                                                            cursor: "pointer"
                                                                                                        }}
                                                                                                        onClick={() => setOpenPickerIndex(index)}
                                                                                                        disabled={streamingStatus !== 0}
                                                                                                    >
                                                                                                        <FaEdit className="p-0 mb-1" />
                                                                                                    </button>

                                                                                                    {/* Duration Picker */}
                                                                                                    {openPickerIndex === index && (
                                                                                                        <div style={{
                                                                                                            position: "absolute",
                                                                                                            bottom: "25px",
                                                                                                            right: "0",
                                                                                                            background: "white",
                                                                                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                                                                                            padding: "10px",
                                                                                                            borderRadius: "5px",
                                                                                                            zIndex: 1100,
                                                                                                            display: "flex",
                                                                                                            alignItems: "center"
                                                                                                        }}>
                                                                                                            <select id="duration-hour-input"
                                                                                                                value={selectedHours}
                                                                                                                onChange={(e) => setSelectedHours(e.target.value.padStart(2, "0"))}
                                                                                                                style={{ padding: "5px", marginRight: "5px" }}
                                                                                                            >
                                                                                                                {Array.from({ length: 24 }, (_, i) => (
                                                                                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                                                                                        {String(i).padStart(2, "0")}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                            </select>
                                                                                                            <span>:</span>
                                                                                                            <select id="duration-minutes-input"
                                                                                                                value={selectedMinutes}
                                                                                                                onChange={(e) => setSelectedMinutes(e.target.value.padStart(2, "0"))}
                                                                                                                style={{ padding: "5px", margin: "0 5px" }}
                                                                                                            >
                                                                                                                {Array.from({ length: 60 }, (_, i) => (
                                                                                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                                                                                        {String(i).padStart(2, "0")}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                            </select>
                                                                                                            <span>:</span>
                                                                                                            <select id="duration-seconds-input"
                                                                                                                value={selectedSeconds}
                                                                                                                onChange={(e) => setSelectedSeconds(e.target.value.padStart(2, "0"))}
                                                                                                                style={{ padding: "5px", marginLeft: "5px" }}
                                                                                                            >
                                                                                                                {Array.from({ length: 60 }, (_, i) => (
                                                                                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                                                                                        {String(i).padStart(2, "0")}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                            </select>

                                                                                                            <button id="duration-success-btn"
                                                                                                                onClick={() => {
                                                                                                                    const totalSeconds =
                                                                                                                        parseInt(selectedHours) * 3600 +
                                                                                                                        parseInt(selectedMinutes) * 60 +
                                                                                                                        parseInt(selectedSeconds);

                                                                                                                    // Update all videos with new timing
                                                                                                                    const updatedContents = [...scheduledContents];
                                                                                                                    updatedContents[index].duration = totalSeconds;

                                                                                                                    // Recalculate all times
                                                                                                                    let currentTime = index === 0 ? new Date(firstDate) : new Date(updatedContents[0].startTime);
                                                                                                                    for (let i = 0; i < updatedContents.length; i++) {
                                                                                                                        const startTime = new Date(currentTime);
                                                                                                                        const endTime = new Date(currentTime.getTime() + (updatedContents[i].duration * 1000));

                                                                                                                        updatedContents[i].startTime = startTime.toISOString();
                                                                                                                        updatedContents[i].endTime = endTime.toISOString();

                                                                                                                        currentTime = endTime;
                                                                                                                    }

                                                                                                                    updateScheduledContents(updatedContents);
                                                                                                                    setOpenPickerIndex(null);
                                                                                                                    updateErrors({ [durationErrorKey]: "" });
                                                                                                                }}
                                                                                                                style={{ marginLeft: "10px", background: "#007bff", color: "white" }}
                                                                                                            >
                                                                                                                <FaCheck />
                                                                                                            </button>
                                                                                                            <button id="duration-cancel-btn"
                                                                                                                onClick={() => setOpenPickerIndex(null)}
                                                                                                                style={{ marginLeft: "5px", background: "#dc3545", color: "white" }}
                                                                                                            >
                                                                                                                X
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                className="bg-transparent ms-4 text-dark"
                                                                                                disabled={streamingStatus !== 0}
                                                                                                onClick={() => {
                                                                                                    if (scheduledIndex === -1) return;

                                                                                                    // Remove the scheduled item
                                                                                                    updateScheduledContents(scheduledContents.filter((_, i) => i !== scheduledIndex));

                                                                                                    // Re-enable the select option (if needed)
                                                                                                    const removedItem = scheduledContents[scheduledIndex];
                                                                                                    if (removedItem?.content) {
                                                                                                        // Find the matching destination ID (assuming `content` is the title)
                                                                                                        const matchingDestination = destination?.find(
                                                                                                            (dest) => dest.title === removedItem.content
                                                                                                        );

                                                                                                        if (matchingDestination) {
                                                                                                            setDisabledDestinationIds((prev) =>
                                                                                                                prev.filter((id) => id !== matchingDestination.id)
                                                                                                            );
                                                                                                        }
                                                                                                    }

                                                                                                    // Clear errors for remaining items
                                                                                                    const errorUpdates = {};
                                                                                                    scheduledContents.forEach((item, index) => {
                                                                                                        errorUpdates[`destinationValid-${index}`] = '';
                                                                                                        errorUpdates[`scheduleDuration-${index}`] = '';
                                                                                                    });
                                                                                                    updateErrors(errorUpdates);
                                                                                                }}
                                                                                            >
                                                                                                <FaTimes />
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </Draggable>
                                                                        );
                                                                    })}


                                                                    {provided.placeholder}
                                                                </tbody>
                                                            </Table>
                                                        </div>

                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "60vh", textAlign: "center" }}>
                                            <p className="fs-5 fw-bold text-muted">{labelDisplay?.[14]?.title}</p>
                                            <p className="text-secondary">{labelDisplay?.[14]?.sub_title}</p>
                                        </div>
                                    )}
                                </div>
                            </Wrapper>

                            {streamingStatus === 1 && nextQueueContents.length > 0 && (
                                <>
                                    <MessageHeading text={"Next Queue"} />
                                    <Wrapper id="playout-next-queue-list-container">
                                        <div className="editplayouttdtd">
                                            <div className="editplayouttdtd">
                                                <DragDropContext onDragEnd={onDragEnd}>
                                                    <Droppable droppableId="next-queue-droppable">
                                                        {(provided) => (
                                                            <div className="content-lists" style={{ overflowX: "auto", width: "100%" }}>
                                                                <Table {...provided.droppableProps} ref={provided.innerRef}>
                                                                    <tbody>
                                                                        {nextQueueContents.map((video, index) => {
                                                                            const scheduledIndex = scheduledContents.findIndex((item) => item === video);
                                                                            const destinationErrorKey = `destinationValid-${scheduledIndex}`;
                                                                            const durationErrorKey = `scheduleDuration-${scheduledIndex}`;
                                                                            // Calculate times based on previous video
                                                                            const prevEndTime = index > 0 ? nextQueueContents[index - 1].endTime : (video.startTime || firstDate);
                                                                            const startTime = new Date(prevEndTime);
                                                                            const endTime = new Date(startTime.getTime() + (video.duration * 1000));

                                                                            // Update video with calculated times
                                                                            const videoWithTimes = {
                                                                                ...video,
                                                                                startTime,
                                                                                endTime
                                                                            };

                                                                            return (
                                                                                <Draggable key={`next-queue-video-${index}`} draggableId={`next-queue-video-${index}`} index={index}>
                                                                                    {(provided) => (
                                                                                        <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                            <td className={` ${playoutDataError?.[destinationErrorKey] ? "custom-border-error" : ''}`} name={destinationErrorKey} ref={(el) => { if (combinedRef.current) { combinedRef.current[destinationErrorKey] = el; } }}>
                                                                                                <div className="d-flex flex-column">
                                                                                                    <span>{(videoWithTimes?.content && videoWithTimes.content.length > 20 ? `${videoWithTimes?.content.substring(0, 20)}...` : videoWithTimes?.content) || (videoWithTimes.type === 'live' ? 'Live Stream' : 'Video')}</span>
                                                                                                    {videoWithTimes?.library_tag && <span className="theme-text-color" style={{ fontSize: "10px", opacity: 0.6 }}>{videoWithTimes?.library_tag}</span>}
                                                                                                </div>   {playoutDataError?.[destinationErrorKey] && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.[destinationErrorKey]}`} classname='errorred  d-block' /></div>)}</td>

                                                                                            <td>
                                                                                                {/* Display in MM/DD/YYYY, HH:MM:SS format */}
                                                                                                {`${(videoWithTimes.startTime.getMonth() + 1).toString().padStart(2, '0')}/` +
                                                                                                    `${videoWithTimes.startTime.getDate().toString().padStart(2, '0')}/` +
                                                                                                    `${videoWithTimes.startTime.getFullYear()}, ` +
                                                                                                    `${videoWithTimes.startTime.getHours().toString().padStart(2, '0')}:` +
                                                                                                    `${videoWithTimes.startTime.getMinutes().toString().padStart(2, '0')}:` +
                                                                                                    `${videoWithTimes.startTime.getSeconds().toString().padStart(2, '0')}`}
                                                                                            </td>
                                                                                            <td>
                                                                                                <div className="d-flex duration-field">
                                                                                                    <div style={{ position: "relative", display: "inline-block" }}>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            id={`playout-next-queue-duration-input-${index}`}
                                                                                                            name={durationErrorKey}
                                                                                                            value={formatDuration(videoWithTimes.duration)}
                                                                                                            readOnly
                                                                                                            className={`custom-input ${playoutDataError?.[durationErrorKey] ? "custom-input-error" : ''}`}
                                                                                                            style={{ width: "103px", height: "30px", border: "none", cursor: "pointer" }}
                                                                                                            onClick={() => {
                                                                                                                const hours = Math.floor(videoWithTimes.duration / 3600);
                                                                                                                const minutes = Math.floor((videoWithTimes.duration % 3600) / 60);
                                                                                                                const seconds = videoWithTimes.duration % 60;
                                                                                                                setSelectedHours(String(hours).padStart(2, "0"));
                                                                                                                setSelectedMinutes(String(minutes).padStart(2, "0"));
                                                                                                                setSelectedSeconds(String(seconds).padStart(2, "0"));
                                                                                                                setOpenPickerIndex(`next-queue-${index}`);
                                                                                                            }}
                                                                                                            ref={(el) => {
                                                                                                                if (combinedRef.current) {
                                                                                                                    combinedRef.current[durationErrorKey] = el;
                                                                                                                }
                                                                                                            }}

                                                                                                        />
                                                                                                        {playoutDataError?.[durationErrorKey] && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${playoutDataError?.[durationErrorKey]}`} classname='errorred  d-block' /></div>)}
                                                                                                        <button
                                                                                                            style={{
                                                                                                                position: "absolute",
                                                                                                                right: "5px",
                                                                                                                top: "50%",
                                                                                                                transform: "translateY(-50%)",
                                                                                                                border: "none",
                                                                                                                background: "transparent",
                                                                                                                cursor: "pointer"
                                                                                                            }}
                                                                                                            onClick={() => setOpenPickerIndex(`next-queue-${index}`)}
                                                                                                        >
                                                                                                            <FaEdit className="p-0 mb-1" />
                                                                                                        </button>

                                                                                                        {/* Duration Picker */}
                                                                                                        {openPickerIndex === `next-queue-${index}` && (
                                                                                                            <div style={{
                                                                                                                position: "absolute",
                                                                                                                bottom: "25px",
                                                                                                                right: "0",
                                                                                                                background: "white",
                                                                                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                                                                                                padding: "10px",
                                                                                                                borderRadius: "5px",
                                                                                                                zIndex: 1100,
                                                                                                                display: "flex",
                                                                                                                alignItems: "center"
                                                                                                            }}>
                                                                                                                <select id="duration-hour-input"
                                                                                                                    value={selectedHours}
                                                                                                                    onChange={(e) => setSelectedHours(e.target.value.padStart(2, "0"))}
                                                                                                                    style={{ padding: "5px", marginRight: "5px" }}
                                                                                                                >
                                                                                                                    {Array.from({ length: 24 }, (_, i) => (
                                                                                                                        <option key={i} value={String(i).padStart(2, "0")}>
                                                                                                                            {String(i).padStart(2, "0")}
                                                                                                                        </option>
                                                                                                                    ))}
                                                                                                                </select>
                                                                                                                <span>:</span>
                                                                                                                <select id="duration-minutes-input"
                                                                                                                    value={selectedMinutes}
                                                                                                                    onChange={(e) => setSelectedMinutes(e.target.value.padStart(2, "0"))}
                                                                                                                    style={{ padding: "5px", margin: "0 5px" }}
                                                                                                                >
                                                                                                                    {Array.from({ length: 60 }, (_, i) => (
                                                                                                                        <option key={i} value={String(i).padStart(2, "0")}>
                                                                                                                            {String(i).padStart(2, "0")}
                                                                                                                        </option>
                                                                                                                    ))}
                                                                                                                </select>
                                                                                                                <span>:</span>
                                                                                                                <select id="duration-seconds-input"
                                                                                                                    value={selectedSeconds}
                                                                                                                    onChange={(e) => setSelectedSeconds(e.target.value.padStart(2, "0"))}
                                                                                                                    style={{ padding: "5px", marginLeft: "5px" }}
                                                                                                                >
                                                                                                                    {Array.from({ length: 60 }, (_, i) => (
                                                                                                                        <option key={i} value={String(i).padStart(2, "0")}>
                                                                                                                            {String(i).padStart(2, "0")}
                                                                                                                        </option>
                                                                                                                    ))}
                                                                                                                </select>

                                                                                                                <button id="duration-success-btn"
                                                                                                                    onClick={() => {
                                                                                                                        const totalSeconds =
                                                                                                                            parseInt(selectedHours) * 3600 +
                                                                                                                            parseInt(selectedMinutes) * 60 +
                                                                                                                            parseInt(selectedSeconds);

                                                                                                                        if (scheduledIndex === -1) return;

                                                                                                                        // Update the matching next queue item in the full schedule list
                                                                                                                        const updatedContents = [...scheduledContents];
                                                                                                                        updatedContents[scheduledIndex] = {
                                                                                                                            ...updatedContents[scheduledIndex],
                                                                                                                            duration: totalSeconds
                                                                                                                        };

                                                                                                                        updateScheduledContents(recalculateNewQueueTimings(updatedContents));
                                                                                                                        setOpenPickerIndex(null);
                                                                                                                        updateErrors({ [durationErrorKey]: "" });
                                                                                                                    }}
                                                                                                                    style={{ marginLeft: "10px", background: "#007bff", color: "white" }}
                                                                                                                >
                                                                                                                    <FaCheck />
                                                                                                                </button>
                                                                                                                <button id="duration-cancel-btn"
                                                                                                                    onClick={() => setOpenPickerIndex(null)}
                                                                                                                    style={{ marginLeft: "5px", background: "#dc3545", color: "white" }}
                                                                                                                >
                                                                                                                    X
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button
                                                                                                    className="bg-transparent ms-4 text-dark"
                                                                                                    onClick={() => {
                                                                                                        if (scheduledIndex === -1) return;

                                                                                                        // Remove the scheduled item
                                                                                                        updateScheduledContents(recalculateNewQueueTimings(scheduledContents.filter((_, i) => i !== scheduledIndex)));

                                                                                                        // Re-enable the select option (if needed)
                                                                                                        const removedItem = scheduledContents[scheduledIndex];
                                                                                                        if (removedItem?.content) {
                                                                                                            // Find the matching destination ID (assuming `content` is the title)
                                                                                                            const matchingDestination = destination?.find(
                                                                                                                (dest) => dest.title === removedItem.content
                                                                                                            );

                                                                                                            if (matchingDestination) {
                                                                                                                setDisabledDestinationIds((prev) =>
                                                                                                                    prev.filter((id) => id !== matchingDestination.id)
                                                                                                                );
                                                                                                            }
                                                                                                        }

                                                                                                        // Clear errors for remaining items
                                                                                                        const errorUpdates = {};
                                                                                                        scheduledContents.forEach((item, index) => {
                                                                                                            errorUpdates[`destinationValid-${index}`] = '';
                                                                                                            errorUpdates[`scheduleDuration-${index}`] = '';
                                                                                                        });
                                                                                                        updateErrors(errorUpdates);
                                                                                                    }}
                                                                                                >
                                                                                                    <FaTimes />
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )}
                                                                                </Draggable>
                                                                            );
                                                                        })}


                                                                        {provided.placeholder}
                                                                    </tbody>
                                                                </Table>
                                                            </div>

                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                            </div>
                                        </div>
                                    </Wrapper>
                                </>
                            )}

                            {Number(playoutData?.play_out?.streaming_status) === 0 ? <AdminCustomButton id={`playout-set-schedule-btn`} className='px-3 py-1 me-3 me-md-0 ms-md-auto d-flex' saveMethod={handleSchedule} saveText={labelDisplay?.[15]?.title} />
                                : Number(playoutData?.play_out?.streaming_status) === 2 ? <AdminCustomButton id={`schedule-cancel`} className='px-3 py-1 me-3 me-md-0 ms-md-auto d-flex' saveMethod={handleStop} saveText={'Cancel Schedule'} />
                                    : <div className="d-flex justify-content-end gap-3">
                                        <AdminCustomButton id={`schedule-update`} className='px-3 py-1 d-flex' saveMethod={handleUpdateNewPrograms} saveText={'Update New Programs'} />
                                        <AdminCustomButton id={`schedule-cancel`} className='px-3 py-1 d-flex' saveMethod={handleStop} saveText={'Stop Stream'} />
                                    </div>
                            }
                        </RightWrapper>
                    </FormContainer>
                </>
            )}

            {playoutData?.play_out?.playout_types === 'single' && (
                <Wrapper>
                    <FormContainer className={`justify-content-between`}>
                        <LeftWrapper custom className={`col-12 col-md-4`}>
                            <MessageLabel noMargin text={labelDisplay?.[41]?.title ?? "Schedule start time"} />
                            <input
                                type="datetime-local"
                                name="date"
                                id="Schedule-date"
                                className="rs-input form-control-lg py-3"
                                min={streamingStatus === 0 ? new Date(new Date().setSeconds(0, 0)).toISOString().slice(0, 16) : undefined}
                                max={streamingStatus === 0 ? new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16) : undefined}
                                value={formatDateForInput(firstDate)}
                                readOnly={streamingStatus !== 0}
                                onChange={(e) => { inputStartDateTimeChange(e.target.value) }}
                                style={{ height: "50px", cursor: streamingStatus !== 0 ? 'default' : 'auto' }}
                                onKeyDown={streamingStatus === 0 ? (e) => e.preventDefault() : undefined}
                                ref={(el) => combinedRef.current['date'] = el}
                            />
                        </LeftWrapper>
                        <RightWrapper custom className={`col-12 col-md-6`}>
                            <MessageLabel noMargin text={labelDisplay?.[41]?.title ?? "HLS URL"} />
                            <AdminCustomInput noMargin className={`py-3`} name="hls_url" onChange={handleInput} value={playoutData?.play_out?.hls_url} ref={(el) => combinedRef.current.hls_url = el} error={playoutDataError?.hls_url} placeHolder={'Provide HLS url'} />
                        </RightWrapper>
                    </FormContainer>
                    <AdminCustomButton text={`Add`} onClick={handleAddProgram} />
                    {singleProgramList?.map((item, index) => (
                        <FormContainer key={index}>
                            <AdminCustomInput name="program_title" value={item?.title} onChange={(e) => handleInputChange(index, 'program_title', e.target.value)} ref={(el) => combinedRef.current.program_title = el} error={playoutDataError?.program_title} placeHolder={`Program title`} />
                            <AdminCustomInput value={item?.start_time} placeHolder={`start time`} />
                        </FormContainer>
                    ))}
                </Wrapper>
            )}

            {/* <FormContainer>
                <BandwidthAnalytics ref={analyticsRef} rtmpKey={playoutData?.play_out?.streamKey} />
            </FormContainer> */}

            <Modal show={openProgramModal} onHide={handleProgramModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Program</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <MessageLabel text="Program Name" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={programForm.name} onChange={handleProgramFormChange} placeHolder="Enter program name" error={playoutDataError?.programName} />
                    </div>
                    <div className="mb-3">
                        <MessageLabel text="Duration (HH:MM:SS)" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="duration" value={programForm.duration} onChange={handleProgramFormChange} onBlur={handleDurationBlur} placeHolder="00:05:00" maxLength={8} error={playoutDataError?.programDuration} />
                        <small className="text-muted">Enter duration in HH:MM:SS format or just digits (e.g., 000500 becomes 00:05:00)</small>
                    </div>
                    <div className="mb-3">
                        <MessageLabel text="URL" className="mandatorySimple" />
                        <AdminCustomInput type="url" name="url" value={programForm.url} onChange={handleProgramFormChange} placeHolder="Enter M3U8 or MP4 URL" error={playoutDataError?.programUrl} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleProgramModalClose}>
                        Cancel
                    </Button>
                    <AdminCustomButton saveText="Submit" saveMethod={handleProgramSubmit} />
                </Modal.Footer>
            </Modal>

            <Modal className="video-upload-UI" show={openVideoUploadModal} onHide={handleProgramModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title><MessageLabel noMargin text={"Upload Your Video"} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                        <div className="dropZoneText d-flex align-items-center justify-content-center">
                            <MessageBox text={`Drag and drop video files here, or click to select files`} classname="theme-text-color" />
                        </div>
                        <input
                            type="file"
                            id="fileInput"
                            accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo"
                            className="w-100 h-100"
                            multiple
                            onChange={(e) => handleLibraryChange(e)}
                        />
                    </div>
                    <MessageSubHeading className={"text-center mt-4"} text={`Max Upload Limit (${storageSetting?.site_storage_limit} ${storageSetting?.site_storage_memory})`} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleProgramModalClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={openRTMPModal} onHide={handleProgramModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title><MessageLabel noMargin text={"Create RTMP"} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <MessageLabel text={`Platform`} className="mandatorySimple" />
                    <AdminCustomSelect name="platform" value={newRTMP?.platform || 'custom'} options={PLATFORM_OPTIONS} ref={(el) => (combinedRef.current.platform = el)} onChange={rtmphandleInput} error={playoutDataError?.platform} />
                    {isRTMPCustomPlatform && (
                        <p className="theme-text-color mb-3" style={{ fontSize: '12px', opacity: 0.6, marginTop: '-8px' }}>Select a platform above or choose "Custom" to enter your own RTMP server details.</p>
                    )}

                    <MessageLabel text={`Title`} className="mandatorySimple" />
                    <AdminCustomInput type="text" name="title" value={newRTMP?.title} ref={(el) => (combinedRef.current.title = el)} onChange={rtmphandleInput} placeHolder={"Ex: Streaming 1"} error={playoutDataError?.title} maxLength={512} />

                    {isRTMPCustomPlatform ? (
                        <>
                            <MessageLabel text={"RTMP URL"} className="mandatorySimple" />
                            <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>Full RTMP URL including the stream key provided by your streaming server.</p>
                            <AdminCustomInput type="text" name="rtmp_url" value={newRTMP?.rtmp_url} ref={(el) => (combinedRef.current.rtmp_url = el)} onChange={rtmphandleInput} placeHolder={"rtmp://example.com/live/streamkey"} error={playoutDataError?.rtmp_url} maxLength={512} />

                            <MessageLabel text={"HLS URL"} className="mandatorySimple" />
                            <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>The HLS playback URL where viewers can watch the live stream.</p>
                            <AdminCustomInput type="text" name="hls_url" value={newRTMP?.hls_url} ref={(el) => (combinedRef.current.hls_url = el)} onChange={rtmphandleInput} placeHolder={"https://example.com/livestream/streamkey.m3u8"} error={playoutDataError?.hls_url} maxLength={512} />
                        </>
                    ) : (
                        <>
                            {/* RTMP Server URL label row */}
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div>
                                    <MessageLabel text={`RTMP Server URL`} className="mandatorySimple mb-0" />
                                    <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>The selected platform RTMP URL is already pre-defined, just enter the stream key only.</p>
                                </div>
                                <label className="d-flex align-items-center gap-1 theme-text-color text-nowrap" style={{ cursor: 'pointer', fontSize: '12px', opacity: 0.8 }}>
                                    <input
                                        type="checkbox"
                                        name="editBaseUrl"
                                        checked={state.editBaseUrl}
                                        onChange={rtmphandleInput}
                                        style={{ width: '14px', height: '14px', accentColor: '#5a8dee', cursor: 'pointer' }}
                                    />
                                    Edit URL
                                </label>
                            </div>
                            <div className="d-flex align-items-center mb-1 rounded overflow-hidden custom-input-border" style={{ background: 'transparent' }}>
                                {state.editBaseUrl ? (
                                    <input
                                        type="text"
                                        name="custom_rtmp_base"
                                        value={newRTMP?.custom_rtmp_base || selectedRTMPPlatformUrl}
                                        onChange={rtmphandleInput}
                                        ref={(el) => (combinedRef.current.custom_rtmp_base = el)}
                                        placeholder="Enter custom RTMP base URL"
                                        maxLength={256}
                                        className="custom-input bg-transparent theme-text-color custom-placeholder border-0"
                                        style={{ outline: 'none', fontSize: '13px', minWidth: '180px', borderRight: '1px solid rgba(255,255,255,0.15)' }}
                                    />
                                ) : (

                                    <span className="px-2 py-2 theme-text-color text-nowrap" style={{ opacity: 0.9, fontSize: '13px', borderRight: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.04)' }}>
                                        {selectedRTMPPlatformUrl}
                                    </span>
                                )}
                                <input
                                    type="text"
                                    name="stream_key"
                                    value={newRTMP?.stream_key || ''}
                                    onChange={rtmphandleInput}
                                    ref={(el) => (combinedRef.current.stream_key = el)}
                                    placeholder="Paste your stream key here"
                                    maxLength={256}
                                    className="custom-input bg-transparent theme-text-color custom-placeholder w-100 border-0"
                                    style={{ outline: 'none' }}
                                />
                            </div>
                            {playoutDataError?.stream_key && (
                                <div className='d-flex align-items-center gap-1 mb-2'>
                                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                                    <MessageBox text={playoutDataError?.stream_key} classname='errorred d-block' />
                                </div>
                            )}

                            {/* Composed URL preview */}
                            {newRTMP?.rtmp_url && (
                                <div className="mb-3 p-2 rounded" style={{ background: 'rgba(255,255,255,0.03)', border: '1px dashed rgba(255,255,255,0.1)' }}>
                                    <MessageLabel text={`Final RTMP URL (auto-generated):`} textAlign="left" />
                                    <AdminCustomInput value={newRTMP?.rtmp_url} isReadonly />
                                </div>
                            )}

                            <MessageLabel text={`Watch / Social Media URL`} />
                            <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>Optional. The public URL where viewers can watch the live stream.</p>
                            <AdminCustomInput type="text" name="watch_youtube_url" value={newRTMP?.watch_youtube_url} ref={(el) => (combinedRef.current.watch_youtube_url = el)} onChange={rtmphandleInput} placeHolder={PLATFORM_WATCH_URLS[newRTMP?.platform] + 'your-id'} error={playoutDataError?.watch_youtube_url} maxLength={512} />
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleProgramModalClose}>
                        Cancel
                    </Button>
                    <AdminCustomButton saveText="Submit" saveMethod={handleRTMPSubmit} />
                </Modal.Footer>
            </Modal>

        </>
    );
};

const mapStateToProps = (state) => ({
    adminSetting: state.siteTheme.adminSetting,
    storageSetting: state.storageSetting.data,
    userDetails: state.userPermission.userDetails,
    siteTheme: state.siteTheme.siteTheme,
    onlyPermission: state.userPermission.onlyPermission
})

export default connect(mapStateToProps)(EditTvplayouts);
